import React, { Component } from "react";
import { connect } from "react-redux";
import $ from "jquery";
import { addSettings, addMsaInfo } from "../../../actions";
import DataTable from "../../../components/Tables/DataTable";
import { tableLoader } from "../../../components/ContentLoaders/table_loader";
import MsaWarning from "../ExtraComponents/MsaWarning";
import SettingsError from "../ExtraComponents/SettingsError";
import PageTitleBreadCrumb from "../ExtraComponents/PageTitleBreadCrumb";
import HelperClass from "./../../../config/helperClass";
import Checkbox from "@material-ui/core/Checkbox";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import {
  listSubAgent,
  sendSubAgentInvite,
  getAgentInviteData,
  deleteInviteSubAgent,
  getSingleSubAgent,
  editSubAgent,
  getSubAgentLogin,
  getEditSubAgentEmailPreview,
  getInviteSubAgentEmailPreview,
} from "./../../../config/api_calls";
import {
  ListAgentAssignRoles,
  editAgentAssignRole,
  ListSubAgentAssignRoles,
  editSubAgentAssignRole,
} from "../../../config/agent_role_api_calls";
import { getCustomSettings } from "./../../../config/reseller_api_calls";
import MutextField from "@material-ui/core/TextField";
import TextareaAutosize from "@material-ui/core/TextareaAutosize";
import { FormLoader } from "../../../components/ContentLoaders/newLoaders/Form";
import { ValidateEmail } from "../../../config/utility";
import { parsePhoneNumberFromString } from "libphonenumber-js";
import dateFormat, { masks } from "dateformat";
import Link from "@material-ui/core/Link";
import DataTableExtended from "../../../components/Tables/DataTableExtended";
import { PhoneInput } from "react-international-phone";
import GooglePlacesAutocomplete from "react-google-places-autocomplete";
import PasswordStrengthBar from "react-password-strength-bar";
import Select from "react-select";
import TextField from "../../../components/InputFields/TextField";
import Tooltip from "@material-ui/core/Tooltip";
import { PhoneNumberUtil } from "google-libphonenumber";
import localization from "../../../localization/enUS";

const auth = new HelperClass();
class Subagents extends Component {
  constructor() {
    super();
    this.state = {
      tableData: [],
      tableLoader: true,
      value: "",
      signedData: [],
      unsignedData: [],
      isRevokeReasonActive: false,
      revoke_reason: "",
      unsigned_email_agreement_accountno: 0,
      liveagent_service: "",
      serviceData: [],
      serviceAssignedData: [],
      packagesAssignedData: [],
      client_services_welcome_content: "",
      client_services_email: "",
      company_id: "",
      company_title: "",
      errorMessage: "",
      successMessage: "",
      disabled: false,
      activation_button: false,
      activation_tick: false,
      activation_cross: false,
      client_services_client_id: "",
      agent_accountno: "",
      errorMessageAgentRole: "",
      successMessageAgentRole: "",
      assignRoleData: [],
      assignSubRoleData: [],
      changedRolesRights: [],
      changedSubRolesRights: [],
      errorMessageSubClientRole: "",
      successMessageSubClientRole: "",
      subassignRoleData: [],
      subassignSubRoleData: [],
      subchangedRolesRights: [],
      subchangedSubRolesRights: [],
      checkedRoleIds: [],
      checkedSubRoleIds: [],
      checkedName: "",
      checkedEmail: "",

      clientErrorMessage: "",
      clientSuccessMessage: "",
      // Role column is gated on the reseller's role_field_enabled setting; when
      // enabled it is revealed and reordered after Title via columnOrder.
      role_field_enabled: false,
      agentTableOptions: {},
      main_client_name: "",
      agent_name: "",
      agent_email: "",
      agent_id: "",
      agent_title: "",
      // Role is a separate field from Title; used by the edit sub-agent form.
      role: "",
      invitation_comment: "",
      tableData_invitedClients: [],
      sub_activeTab: localStorage.getItem("sub_activeTab") || "tabItem8",
      errorMessageInvite: "",
      successMessageInvite: "",
      invitation_comment: "",
      tableData_invitedAgents: [],
      activeTabCP: "tabItem7",
      delete_id: "",
      toggleButtonText: "Allow PO Box Address",
      useGooglePlaces: true,
      errorMessageEdit: "",
      successMessageEdit: "",
      isEmailChanged: false,
      proceedAfterEmailModal: false,
      agent_phone: "",
      agent_company: "",
      agent_status: "",
      sub_agent_id: "",
      agent_password: "",
      agent_c_password: "",
      agent_address: "",
      agent_address2: "",
      agent_city: "",
      agent_state: "",
      agent_zip: "",
      agent_country: "",
      sharelink_limit: "",
      errorMessageEdit: "",
      successMessageEdit: "",
      errorName: "",
      errorAgentStatus: "",
      errorAgentCompany: "",
      errorAgentEmail: "",
      errorAgentPhone: "",
      errorAgentAddress: "",
      errorAgentCity: "",
      errorAgentState: "",
      errorAgentZip: "",
      errorAgentCountry: "",
      errorAgentPassword: "",
      errorCPassword: "",
      notifyCheckBox: false,
      original_client_update_email: "",
      loginErrorMessage: "",
      login_url: "",
      showLoginModal: false,
      original_client_update_email: "",
      address_autocomplete: true,
      address_validation: true,

      columnServices: [
        { name: "Date Added" },
        { name: "Title" },
        { name: "Name" },
        { name: "Email" },
        {
          name: "Status",
          options: {
            customBodyRender: (value, tableMeta, updateValue) => {
              return <div>{this.setStatus(value, tableMeta)}</div>;
            },
          },
        },
        // {
        //   name: "Action",
        //   options: {
        //     customBodyRender: (value, tableMeta, updateValue) => {
        //       return (
        //         <div>
        //           <div
        //             className="nk-tb-col nk-tb-col-tools"
        //             style={{ padding: "0px" }}
        //           >
        //             <ul className="nk-tb-actions gx-1">
        //               <li>
        //                 <div className="drodown">
        //                   <a
        //                     href="#"
        //                     title="Other Actions"
        //                     className="dropdown-toggle btn btn-icon  btn-outline-light"
        //                     data-toggle="dropdown"
        //                   >
        //                     <em className="icon ni ni-more-h"></em>
        //                   </a>
        //                   <div className="dropdown-menu dropdown-menu-right">
        //                     <ul className="link-list-opt no-bdr">
        //                       <li>
        //                         <a
        //                           style={{ cursor: "pointer" }}
        //                           data-toggle="tooltip"
        //                           data-placement="left"
        //                           onClick={() =>
        //                             this.editAgentForm(value, tableMeta)
        //                           }
        //                           title="Edit sub user profile"
        //                           disabled={
        //                             this.props.is_msa_signed === "No" ||
        //                             this.props.defaultSettings === "missing"
        //                               ? true
        //                               : false
        //                           }
        //                         >
        //                           <em className="icon ni ni-edit"></em>
        //                           <span>Edit Sub User</span>
        //                         </a>
        //                       </li>
        //                       <li>
        //                         <a
        //                           style={{ cursor: "pointer" }}
        //                           data-toggle="tooltip"
        //                           data-placement="left"
        //                           onClick={() =>
        //                             this.agentLogin(value, tableMeta)
        //                           }
        //                           title="Login to the sub user dashboard"
        //                           disabled={
        //                             this.props.is_msa_signed === "No" ||
        //                             this.props.defaultSettings === "missing"
        //                               ? true
        //                               : false
        //                           }
        //                         >
        //                           <em className="icon ni ni-signin"></em>
        //                           <span>Dashboard</span>
        //                         </a>
        //                       </li>
        //                       <li>
        //                         <a
        //                           style={{ cursor: "pointer" }}
        //                           data-toggle="tooltip"
        //                           data-placement="left"
        //                           onClick={() =>
        //                             this.subagentAssignRole(value, tableMeta)
        //                           }
        //                           title="Assign roles to the sub user"
        //                           disabled={
        //                             this.props.is_msa_signed === "No" ||
        //                             this.props.defaultSettings === "missing"
        //                               ? true
        //                               : false
        //                           }
        //                         >
        //                           <em className="icon ni ni-grid-c"></em>
        //                           <span>Assign Menu</span>
        //                         </a>
        //                       </li>
        //                     </ul>
        //                   </div>
        //                 </div>
        //               </li>
        //             </ul>
        //           </div>
        //         </div>
        //       );
        //     },
        //   },
        // },
        {
          name: "Action",
          options: {
            customBodyRender: (value, tableMeta, updateValue) => {
              const isDisabled =
                this.props.is_msa_signed === "No" ||
                this.props.defaultSettings === "missing";

              const disabledMsg =
                "Disabled because MSA is not signed or default settings are missing.";

              return (
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    gap: 12,
                    minHeight: 36,
                  }}
                >
                  {/* Edit Sub User */}
                  <Tooltip
                    title={isDisabled ? disabledMsg : "Edit sub user profile"}
                  >
                    <span
                      role="button"
                      tabIndex={0}
                      aria-disabled={isDisabled}
                      onClick={() => {
                        if (!isDisabled) this.editAgentForm(value, tableMeta);
                      }}
                      style={{
                        display: "inline-flex",
                        alignItems: "center",
                        cursor: isDisabled ? "not-allowed" : "pointer",
                        opacity: isDisabled ? 0.3 : 1,
                      }}
                    >
                      <em
                        className="icon ni ni-edit text-primary"
                        style={{ fontSize: 20 }}
                      />
                    </span>
                  </Tooltip>

                  {/* Dashboard (with divider on left) */}
                  <Tooltip
                    title={
                      isDisabled ? disabledMsg : "Login to sub user dashboard"
                    }
                  >
                    <span
                      role="button"
                      tabIndex={0}
                      aria-disabled={isDisabled}
                      onClick={() => {
                        if (!isDisabled) this.agentLogin(value, tableMeta);
                      }}
                      style={{
                        display: "inline-flex",
                        alignItems: "center",
                        cursor: isDisabled ? "not-allowed" : "pointer",
                        opacity: isDisabled ? 0.3 : 1,
                      }}
                    >
                      <em
                        className="icon ni ni-signin text-secondary"
                        style={{
                          fontSize: 20,
                          paddingLeft: 8,
                          borderLeft: "1px solid rgba(0,0,0,0.2)", // center divider
                        }}
                      />
                    </span>
                  </Tooltip>

                  {/* Assign Menu (with divider on left) */}
                  <Tooltip
                    title={
                      isDisabled ? disabledMsg : "Assign roles to sub user"
                    }
                  >
                    <span
                      role="button"
                      tabIndex={0}
                      aria-disabled={isDisabled}
                      onClick={() => {
                        if (!isDisabled)
                          this.subagentAssignRole(value, tableMeta);
                      }}
                      style={{
                        display: "inline-flex",
                        alignItems: "center",
                        cursor: isDisabled ? "not-allowed" : "pointer",
                        opacity: isDisabled ? 0.3 : 1,
                      }}
                    >
                      <em
                        className="icon ni ni-grid-alt text-info"
                        style={{
                          fontSize: 20,
                          paddingLeft: 8,
                          borderLeft: "1px solid rgba(0,0,0,0.2)", // center divider
                        }}
                      />
                    </span>
                  </Tooltip>
                </div>
              );
            },
          },
        },
        {
          // Role data is at row index 6. Hidden unless the reseller enabled the
          // Role field; revealed + reordered after Title via columnOrder.
          name: "Role",
          options: {
            display: false,
            customBodyRender: (value) => (
              <div>{value && String(value).trim() !== "" ? value : "-"}</div>
            ),
          },
        },
      ],
      columnServices_invitedAgents: [
        { name: "Sub User Name" },
        { name: "Sub User Email" },
        {
          name: `${localization.specificPortals.agentLabel.toUpperCase()} NAME`,
          label: "Partner Name",
        },
        {
          name: `${localization.specificPortals.agentLabel.toUpperCase()} EMAIL`,
          label: "Partner Email",
        },
        {
          name: "Invited On",
          options: {
            customBodyRender: (value, tableMeta, updateValue) => {
              return <div>{this.format_date(value)}</div>;
            },
            filter: false,
          },
        },
        {
          name: `${localization.specificPortals.agentLabel.toUpperCase()} ID`,
          options: { display: false },
        },
        { name: "ID", options: { display: false } },
        {
          name: "Comment",
          options: {
            customBodyRender: (value, tableMeta, updateValue) => {
              return (
                <div onClick={() => this.assignedTo(value, tableMeta)}>
                  <span
                    className="badge badge-outline-secondary"
                    style={{ cursor: "pointer" }}
                  >
                    View
                  </span>
                </div>
              );
            },
          },
        },
        {
          name: "Link",
          options: {
            customBodyRender: (value, tableMeta, updateValue) => {
              const rowId = tableMeta.rowData[5];
              const textToCopy = tableMeta.rowData[7];
              if (textToCopy && textToCopy.trim() !== "") {
                return (
                  <div
                    onClick={() => this.copyToClipboard(textToCopy, rowId)}
                    style={{ cursor: "pointer" }}
                  >
                    <span className="d-flex align-items-center">
                      <i
                        className={`icon ni ${
                          this.state.copiedRowId === rowId
                            ? "ni-check"
                            : "ni-copy"
                        }`}
                      ></i>
                      <span>
                        {this.state.copiedRowId === rowId ? "Copied" : "Copy"}
                      </span>
                    </span>
                  </div>
                );
              } else {
                return <div>---</div>;
              }
            },
          },
        },
        // {
        //   name: "Actions",
        //   options: {
        //     customBodyRender: (value, tableMeta) => {
        //       return (
        //         <div>
        //           <div
        //             className="nk-tb-col nk-tb-col-tools"
        //             style={{ padding: "0px" }}
        //           >
        //             <ul className="nk-tb-actions gx-1">
        //               <li>
        //                 <div className="drodown">
        //                   <a
        //                     href="#"
        //                     className="dropdown-toggle btn btn-icon btn-outline-light"
        //                     data-toggle="dropdown"
        //                   >
        //                     <em className="icon ni ni-more-h"></em>
        //                   </a>
        //                   <div className="dropdown-menu dropdown-menu-right">
        //                     <ul className="link-list-opt no-bdr">
        //                       <li>
        //                         <a
        //                           onClick={() =>
        //                             this.deleteAlert(tableMeta.rowData[5])
        //                           }
        //                           style={{ cursor: "pointer" }}
        //                           data-toggle="tooltip"
        //                           data-placement="top"
        //                           title="Delete Sub User Invitation"
        //                           disabled={
        //                             this.props.is_msa_signed === "No" ||
        //                             this.props.defaultSettings === "missing"
        //                               ? true
        //                               : false
        //                           }
        //                         >
        //                           <em className="icon ni ni-trash"></em>
        //                           <span>Delete Invite</span>
        //                         </a>
        //                       </li>
        //                       <li>
        //                         <a
        //                           onClick={() =>
        //                             this.resendInvite(
        //                               tableMeta.rowData[1],
        //                               tableMeta.rowData[0],
        //                               tableMeta.rowData[6]
        //                             )
        //                           }
        //                           style={{ cursor: "pointer" }}
        //                           data-toggle="tooltip"
        //                           data-placement="top"
        //                           title="Resend Activation"
        //                           disabled={
        //                             this.props.is_msa_signed === "No" ||
        //                             this.props.defaultSettings === "missing"
        //                               ? true
        //                               : false
        //                           }
        //                         >
        //                           <em className="icon ni ni-signin"></em>
        //                           <span>Resend Invite</span>
        //                         </a>
        //                       </li>
        //                     </ul>
        //                   </div>
        //                 </div>
        //               </li>
        //             </ul>
        //           </div>
        //         </div>
        //       );
        //     },
        //   },
        // },
        {
          name: "Actions",
          label: "Actions",
          options: {
            customBodyRender: (value, tableMeta) => {
              const isDisabled =
                this.props.is_msa_signed === "No" ||
                this.props.defaultSettings === "missing";

              return (
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    gap: 8,
                    minHeight: 36,
                  }}
                >
                  {/* Delete Invite */}
                  <Tooltip title="Delete Sub User Invitation" placement="top">
                    <a
                      onClick={() => {
                        if (isDisabled) return;
                        this.deleteAlert(tableMeta.rowData[5]);
                      }}
                      style={{
                        cursor: isDisabled ? "not-allowed" : "pointer",
                        opacity: isDisabled ? 0.3 : 1,
                      }}
                    >
                      <em
                        className="icon ni ni-trash text-danger"
                        style={{ fontSize: 20 }}
                      />
                    </a>
                  </Tooltip>

                  {/* Resend Invite */}
                  <Tooltip title="Resend Invite" placement="top">
                    <a
                      onClick={() => {
                        if (isDisabled) return;
                        this.resendInvite(
                          tableMeta.rowData[1],
                          tableMeta.rowData[0],
                          tableMeta.rowData[6],
                        );
                      }}
                      style={{
                        cursor: isDisabled ? "not-allowed" : "pointer",
                        opacity: isDisabled ? 0.3 : 1,
                      }}
                    >
                      <em
                        className="icon ni ni-signin text-primary"
                        style={{
                          fontSize: 20,
                          paddingLeft: 5,
                          borderLeft: "1px solid rgb(0 0 0 / 87%)", // center divider
                        }}
                      />
                    </a>
                  </Tooltip>
                </div>
              );
            },
          },
        },
      ],
    };
  }

  subagentAssignRole = async (value, tableMeta) => {
    // console.log("value: ", value);
    const agentId = tableMeta.rowData[5];
    const agentEmail = tableMeta.rowData[3];
    this.setState({
      errorMessageAgentRole: "",
      successMessageAgentRole: "",
      assignRoleData: [],
      assignSubRoleData: [],
      changedRolesRights: [],
      changedSubRolesRights: [],
      agentRoleLoader: true,
      disableRoleBtn: false,
      disableSubRoleBtn: false,
      rolesAgentName: tableMeta.rowData[2] + " (" + tableMeta.rowData[1] + ")",
      checkedName: tableMeta.rowData[2],
      checkedEmail: tableMeta.rowData[3],
    });
    window.$("#modalSubAgentAssignRole").modal("show");
    this.getSubAgentRoleData(agentId, agentEmail);
  };

  getSubAgentRoleData = async (agentId, agentEmail) => {
    const listSubAgentAssignRoles = await ListSubAgentAssignRoles(
      auth.getAccount(),
      auth.getToken(),
      agentId,
      agentEmail,
    );

    // console.log("ListSubAgentRoles Res: ", listSubAgentAssignRoles.data.data);
    if (
      listSubAgentAssignRoles.data.status === 403 ||
      listSubAgentAssignRoles.data.errors === "authentication missing" ||
      listSubAgentAssignRoles.data.errors === "jwt expired"
    ) {
      auth.logout();
    } else if (listSubAgentAssignRoles.data.status === 404) {
      //window.location.replace("/error");
    } else if (
      listSubAgentAssignRoles.data.status === 200 &&
      listSubAgentAssignRoles.data.message === "success"
    ) {
      const assignRoleData = listSubAgentAssignRoles.data.data.roles;
      const assignSubRoleData = listSubAgentAssignRoles.data.data.subroles;
      const allRoleData = listSubAgentAssignRoles.data.data.Allroles.map(
        (role) => {
          const isActiveRole = assignRoleData.some(
            (assignedRole) =>
              assignedRole.alt === role.alt && assignedRole.isactive === 1,
          );
          return {
            ...role,
            isChecked: isActiveRole,
          };
        },
      );

      const allSubRoleData = listSubAgentAssignRoles.data.data.Allsubroles.map(
        (subRole) => {
          const isActiveSubRole = assignSubRoleData.some(
            (assignedSubRole) =>
              assignedSubRole.alt === subRole.alt &&
              assignedSubRole.isactive === 1,
          );
          return {
            ...subRole,
            isChecked: isActiveSubRole,
          };
        },
      );

      this.setState({
        assignRoleData,
        assignSubRoleData,
        allRoleData,
        allSubRoleData,
        agentRoleLoader: false,
      });

      const initialActiveRoles = assignRoleData
        .filter((role) => role.isactive === 1)
        .map((role) => ({
          alt: role.alt,
          isChecked: true,
        }));

      const initialActiveSubRoles = assignSubRoleData
        .filter((subRole) => subRole.isactive === 1)
        .map((subRole) => ({
          id: subRole.id,
          isChecked: true,
        }));

      this.setState({
        changedRolesRights: initialActiveRoles,
        changedSubRolesRights: initialActiveSubRoles,
      });
    } else {
      //window.location.replace("/error");
    }
  };

  setStatus = (value, tableMeta) => {
    let domain_str = tableMeta.rowData[4];
    //console.log("domain_str: ", domain_str);
    if (domain_str === "active") {
      return (
        <div>
          <span className="badge badge-outline-success">
            {" "}
            <em className="icon ni ni-done" title="Active"></em> Active
          </span>
        </div>
      );
    } else {
      return (
        <div>
          <span className="badge badge-outline-danger">
            {" "}
            <em className="icon ni ni-alert-c"></em> Inactive
          </span>
        </div>
      );
    }
  };

  async componentDidMount() {
    let agent_id = this.props.props.match.params.id;
    this.setState({
      agent_id: agent_id,
    });
    const clientsResponce = await listSubAgent(
      auth.getAccount(),
      auth.getToken(),
      Number(agent_id),
    );

    // console.log("Client Data: ", clientsResponce.data);
    if (
      clientsResponce.data.status === 403 ||
      clientsResponce.data.errors === "authentication missing" ||
      clientsResponce.data.errors === "jwt expired"
    ) {
      auth.logout();
    } else if (
      clientsResponce.data.status === 404 ||
      clientsResponce.data.note === "missing"
    ) {
      // window.location.replace("/error");
      // console.log("settings missing");
      this.setState({
        tableLoader: false,
      });
    } else if (
      clientsResponce.data.status === 200 &&
      clientsResponce.data.message === "success"
    ) {
      this.setState({
        tableData: clientsResponce.data.data,
        tableLoader: false,
      });
    } else {
      this.setState({
        tableLoader: false,
      });
      // window.location.replace("/error");
    }
    this.getCustomSettings();
  }

  addMenuHistoryLeft = (link) => {
    this.props.props.history.push(link);
  };

  handleEditorChange = (content, editor) => {
    this.setState({
      client_services_welcome_content: content,
    });
    //console.log("Content was updated:", content);
  };

  defaultText = (value, tableMeta) => {
    //console.log("tableMeta.rowData: ", tableMeta.rowData[9]);
    let is_default = value;

    if (is_default === "inactive") {
      return (
        <span className="badge badge-outline-danger">
          <em className="icon ni ni-signin"></em> Inactive
        </span>
      );
    } else if (is_default === "active") {
      return (
        <span className="badge badge-outline-success">
          <em className="icon ni ni-done"></em> Active
        </span>
      );
    }
  };

  handleChange = async (event) => {
    const { target } = event;
    let value = target.type === "radio" ? target.checked : target.value;
    const { name } = target;

    if (name === "name") {
      value = value.replace(/[^a-zA-Z\s'.,\-:()|!@]/g, "");
    } else if (name === "agent_company") {
      value = value.replace(/[^a-zA-Z0-9\s_\-.,&:()|!@]/g, "");
    } else if (name === "title") {
      value = value.replace(/[^a-zA-Z0-9\s_\-.,&:()|!@]/g, "");
    }

    if (name === "agent_email") {
      const { original_client_update_email } = this.state;

      const isChanged =
        (value || "").trim() !== (original_client_update_email || "").trim();

      this.setState({ isEmailChanged: isChanged }, () => {
        // console.log("Original Email:", original_client_update_email);
        // console.log("New Email:", value);
        // console.log("isEmailChanged:", this.state.isEmailChanged);
      });
    }

    // console.log(name);
    this.setState({
      [name]: value,
    });
  };

  formatPhoneNumber = (phoneNumber) => {
    const phoneNumberObj = parsePhoneNumberFromString(phoneNumber);
    if (phoneNumberObj) {
      if (phoneNumberObj.country === "US") {
        const nationalNumber = phoneNumberObj
          .formatNational()
          .replace(/\D/g, ""); // e.g. "2123727200"
        const areaCode = nationalNumber.slice(0, 3);
        const firstPart = nationalNumber.slice(3, 6);
        const secondPart = nationalNumber.slice(6);
        return `(${areaCode}) ${firstPart}-${secondPart}`;
      }
      return phoneNumberObj.formatInternational();
    }
    return phoneNumber; // Return original number if parsing fails
  };

  setNewClientSettings = async () => {
    this.setState({
      clientErrorMessage: "",
      clientSuccessMessage: "",
      client_name: "",
      client_email: "",
      invitation_comment: "",
    });
    window.$("#modalAddNewClient").modal("show");
  };

  changedAllRolesRights = (event) => {
    const { name, checked } = event.target;

    // Update checkedRoleIds in the state
    const { checkedRoleIds } = this.state;
    const updatedCheckedRoleIds = checked
      ? [...checkedRoleIds, name] // add ID if checked
      : checkedRoleIds.filter((id) => id !== name); // remove ID if unchecked

    this.setState({ checkedRoleIds: updatedCheckedRoleIds });

    // Update allRoleData with isChecked property
    const { allRoleData, allSubRoleData } = this.state;
    const updatedAllRoleData = allRoleData.map((role) => {
      if (role.id.toString() === name) {
        return {
          ...role,
          isChecked: checked,
        };
      }
      return role;
    });

    // Update associated sub roles
    const updatedAllSubRoleData = allSubRoleData.map((subRole) => {
      if (subRole.role_id.toString() === name) {
        return {
          ...subRole,
          isChecked: checked,
        };
      }
      return subRole;
    });

    this.setState({
      allRoleData: updatedAllRoleData,
      allSubRoleData: updatedAllSubRoleData,
    });
  };

  changedAllSubRolesRights = (event) => {
    const { name, checked } = event.target;

    // Update checkedSubRoleIds in the state
    const { checkedSubRoleIds } = this.state;
    const updatedCheckedSubRoleIds = checked
      ? [...checkedSubRoleIds, name] // add ID if checked
      : checkedSubRoleIds.filter((id) => id !== name); // remove ID if unchecked

    this.setState({ checkedSubRoleIds: updatedCheckedSubRoleIds });

    // Update allSubRoleData with isChecked property
    const { allSubRoleData } = this.state;
    const updatedAllSubRoleData = allSubRoleData.map((subRole) => {
      if (subRole.tabdetailid.toString() === name) {
        return {
          ...subRole,
          isChecked: checked,
        };
      }
      return subRole;
    });

    this.setState({ allSubRoleData: updatedAllSubRoleData });
  };

  handleSubmitRoleCheckbox = async (name, email) => {
    this.setState({
      errorMessageAgentRole: "",
      successMessageAgentRole: "",
      disableRoleBtn: true,
    });

    const { allRoleData, allSubRoleData } = this.state;

    // Prepare the CheckRoleFields array with IDs and isactive status
    const CheckRoleFields = allRoleData.map((role) => ({
      id: role.id,
      isactive: role.isChecked ? 1 : 0,
    }));

    const CheckSubRoleFields = allSubRoleData.map((role) => ({
      id: role.tabdetailid,
      isactive: role.isChecked ? 1 : 0,
    }));

    try {
      // Call the backend API to save the roles
      const saveResponce = await editAgentAssignRole(
        auth.getAccount(),
        auth.getToken(),
        CheckRoleFields,
        CheckSubRoleFields,
        name,
        email,
      );

      // Handle response status
      if (
        saveResponce.data.status === 403 ||
        saveResponce.data.errors === "authentication missing" ||
        saveResponce.data.errors === "jwt expired"
      ) {
        auth.logout();
      } else if (saveResponce.data.status === 404) {
        this.setState({
          errorMessageAgentRole: `There is some error while updating the ${localization.specificPortals.agentText} menu.`,
          successMessageAgentRole: "",
          disableRoleBtn: false,
        });
      } else if (
        saveResponce.data.status === 200 &&
        saveResponce.data.message === "success"
      ) {
        this.setState({
          errorMessageAgentRole: "",
          successMessageAgentRole: `${localization.specificPortals.agentText} menu updated successfully.`,
          disableRoleBtn: false,
        });
        setTimeout(() => {
          window.$("#modalSubAgentAssignRole").modal("hide");
        }, 3000);
      } else {
        this.setState({
          errorMessageAgentRole: saveResponce.data.message,
          successMessageAgentRole: "",
          disableRoleBtn: false,
        });
      }
    } catch (error) {
      console.error("Error while saving roles:", error);
      this.setState({
        errorMessageAgentRole: "An error occurred while saving menu.",
        successMessageAgentRole: "",
        disableRoleBtn: false,
      });
    }
  };

  setNewAgentSettings = async () => {
    this.setState({
      errorMessageInvite: "",
      successMessageInvite: "",
      agent_name: "",
      agent_email: "",
      invitation_comment: "",
    });
    window.$("#modalAddNewAgent").modal("show");
  };

  saveNewAgent = async () => {
    const { agent_name, agent_email, invitation_comment, agent_id } =
      this.state;
    this.setState({
      errorMessageInvite: "",
      successMessageInvite: "",
      disabled: true,
    });

    if (agent_name === "") {
      this.setState({
        errorMessageInvite: "Please enter the name.",
        successMessageInvite: "",
        disabled: false,
      });
    } else if (agent_email === "") {
      this.setState({
        errorMessageInvite: "Please enter the email address.",
        successMessageInvite: "",
        disabled: false,
      });
    } else if (ValidateEmail(agent_email) === false) {
      this.setState({
        errorMessageInvite: "Please enter the valid email address.",
        successMessageInvite: "",
        disabled: false,
      });
    } else if (invitation_comment === "") {
      this.setState({
        errorMessageInvite: "Please enter the comment.",
        successMessageInvite: "",
        disabled: false,
      });
    } else {
      const servicesResponce = await sendSubAgentInvite(
        auth.getAccount(),
        auth.getToken(),
        agent_email,
        agent_name,
        invitation_comment,
        agent_id,
      );

      // console.log("agentsResponce.data.data: ", servicesResponce.data);

      if (
        servicesResponce.data.status === 403 ||
        servicesResponce.data.errors === "authentication missing" ||
        servicesResponce.data.errors === "jwt expired"
      ) {
        auth.logout();
      } else if (servicesResponce.data.status === 409) {
        this.setState({
          errorMessageInvite:
            "An account with this email already exists. Invitation not sent.",
          successMessageInvite: "",
          disabled: false,
        });
      } else if (servicesResponce.data.status === 404) {
        this.setState({
          errorMessageInvite:
            "There is some error while sending invite to the sub user.",
          successMessageInvite: "",
          disabled: false,
        });
      } else if (
        servicesResponce.data.status === 200 &&
        servicesResponce.data.message === "success"
      ) {
        this.setState({
          errorMessageInvite: "",
          successMessageInvite: "Invite successfully sent to the sub user.",
          disabled: false,
          client_email: "",
          client_name: "",
          tableData_invitedClients: servicesResponce.data.invited_clients,
        });
        setTimeout(() => {
          window.location.reload();
        }, 3000);
      } else {
        this.setState({
          errorMessageInvite:
            "There is some error while sending invite to the sub user.",
          successMessageInvite: "",
          disabled: false,
        });
      }
    }
    setTimeout(() => {
      this.setState({
        errorMessageInvite: "",
        successMessageInvite: "",
      });
    }, 4000);
  };

  handleTabClick = (tabId) => {
    this.setState({ activeTabCP: tabId });
  };

  format_date = (value, tableMeta) => {
    let date = value;
    return dateFormat(date, "mm-dd-yyyy");
  };

  getInviteData = async () => {
    const servicesResponce = await getAgentInviteData(
      auth.getAccount(),
      auth.getToken(),
      this.state.agent_id,
    );
    // console.log("Available Sub Users: ", servicesResponce.data);

    if (
      servicesResponce.data.status === 403 ||
      servicesResponce.data.errors === "authentication missing" ||
      servicesResponce.data.errors === "jwt expired"
    ) {
      auth.clientLogout();
    } else if (servicesResponce.data.status === 404) {
      this.setState({
        tableLoader: false,
        tableLoaderListing: false,
      });
    } else if (servicesResponce.data.status === 200) {
      this.setState({
        tableData_invitedAgents: servicesResponce.data.invited_agents,
        tableLoader: false,
        tableLoaderListing: false,
      });
    } else {
      this.setState({
        tableLoader: false,
        tableLoaderListing: false,
      });
    }
  };

  assignedTo = (value, tableMeta) => {
    let invitation_comment = tableMeta.rowData[6];
    this.setState(
      {
        invitation_comment: invitation_comment,
      },
      () => {
        window.$("#modalInvitationComment").modal("show");
      },
    );
  };

  copyToClipboard = (text, rowId) => {
    navigator.clipboard.writeText(text);
    this.setState({ copiedRowId: rowId });
    setTimeout(() => {
      this.setState({ copiedRowId: null });
    }, 3000);
  };

  deleteAlert = async (value) => {
    let id = value;
    this.setState({
      delete_id: id,
    });
    window.$("#modalDeleteAlert").modal("show");
  };

  modalHideDel = () => {
    window.$("#modalDeleteAlert").modal("hide");
  };

  deleteInviteAgent = async () => {
    let agent_id = this.state.delete_id;

    this.setState({
      errorMessageInvite: "",
      successMessageInvite: "",
      disabled: true,
    });

    const userResponce = await deleteInviteSubAgent(
      auth.getAccount(),
      auth.getToken(),
      agent_id,
    );

    // console.log("deleteClientInvite: ", userResponce.data);

    if (
      userResponce.data.status === 403 ||
      userResponce.data.errors === "authentication missing" ||
      userResponce.data.errors === "jwt expired"
    ) {
      auth.logout();
    } else if (
      userResponce.data.status === 404 &&
      userResponce.data.message === "fail" &&
      userResponce.data.note !== ""
    ) {
      this.setState({
        errorMessageInvite: "Error deleting the invited sub user.",
        successMessageInvite: "",
        disabled: false,
      });
    } else if (
      userResponce.data.status === 200 &&
      userResponce.data.message === "success"
    ) {
      this.setState({
        errorMessageInvite: "",
        successMessageInvite: "Invited Sub User deleted successfully.",
        disabled: false,
      });

      setTimeout(function () {
        window.location.reload();
        window.$("#modalDeleteAlert").modal("hide");
      }, 3000);
    } else {
      this.setState({
        errorMessageInvite: "Error deleting the invited sub user.",
        successMessageInvite: "",
        disabled: false,
      });
    }
  };

  resendInvite = async (agent_email, agent_name, invitation_comment) => {
    this.setState({
      errorMessageInvite: "",
      successMessageInvite: "",
      disabled: true,
    });

    const servicesResponce = await sendSubAgentInvite(
      auth.getAccount(),
      auth.getToken(),
      agent_email,
      agent_name,
      invitation_comment,
      this.state.agent_id,
    );

    window.$("#modalresendInvitation").modal("show");

    // console.log("agentsResponce.data.data: ", servicesResponce.data);

    if (
      servicesResponce.data.status === 403 ||
      servicesResponce.data.errors === "authentication missing" ||
      servicesResponce.data.errors === "jwt expired"
    ) {
      auth.logout();
    } else if (servicesResponce.data.status === 409) {
      this.setState({
        errorMessageInvite:
          "An account with this email already exists. Invitation not sent.",
        successMessageInvite: "",
        disabled: false,
      });
    } else if (servicesResponce.data.status === 404) {
      this.setState({
        errorMessageInvite: "Error sending invitation email.",
        successMessageInvite: "",
        disabled: false,
      });
    } else if (
      servicesResponce.data.status === 200 &&
      servicesResponce.data.message === "success"
    ) {
      this.setState(
        {
          errorMessageInvite: "",
          successMessageInvite: "Invitation email sent successfully.",
          disabled: false,
        },
        () => {
          setTimeout(() => {
            window.location.reload();
          }, 3000);
        },
      );
    } else {
      this.setState({
        errorMessageInvite: "Error Sending Activation Email",
        successMessageInvite: "",
        disabled: false,
      });
    }
  };

  modalHideResend = () => {
    window.$("#modalresendInvitation").modal("hide");
  };

  editAgentForm = async (value, tableMeta) => {
    this.setState({
      modalDataLoading: true,
      isEmailChanged: false,
      showEmailWarning: false,
      proceedAfterEmailModal: false,
    });
    let agent_id = tableMeta.rowData[5];
    const servicesResponce = await getSingleSubAgent(
      auth.getAccount(),
      auth.getToken(),
      agent_id,
    );
    // console.log("servicesResponce.data.data: ", servicesResponce.data);

    if (
      servicesResponce.data.status === 403 ||
      servicesResponce.data.errors === "authentication missing" ||
      servicesResponce.data.errors === "jwt expired"
    ) {
      auth.logout();
    } else if (servicesResponce.data.status === 404) {
      //window.location.replace("/error");
    } else if (
      servicesResponce.data.status === 200 &&
      servicesResponce.data.message === "success"
    ) {
      let agent_status = "0";
      if (
        servicesResponce.data.data[0][6] &&
        servicesResponce.data.data[0][6] === "active"
      ) {
        agent_status = "1";
      }
      this.setState({
        title: servicesResponce.data.data[0][0],
        name: servicesResponce.data.data[0][1],
        agent_email: servicesResponce.data.data[0][2],
        original_client_update_email: servicesResponce.data.data[0][2],
        agent_phone: servicesResponce.data.data[0][3],
        sub_agent_id: servicesResponce.data.data[0][4],
        agent_company: servicesResponce.data.data[0][5],
        agent_status: agent_status,
        sharelink_limit: servicesResponce.data.data[0][7],
        agent_address: servicesResponce.data.data[0][8],
        agent_address2: servicesResponce.data.data[0][9],
        agent_city: servicesResponce.data.data[0][10],
        agent_state: servicesResponce.data.data[0][11],
        agent_zip: servicesResponce.data.data[0][12],
        agent_country: servicesResponce.data.data[0][13],
        agent_isVerified: servicesResponce.data.data[0][14],
        // Role is a separate field from Title; prefill for the edit form.
        role: servicesResponce.data.data[0][15] || "",
        agent_password: "",
        tableLoader: false,
      });
      window.$("#modalFormDetail").modal("show");
    } else {
      // window.location.replace("/error");
    }
  };

  handleToggle = () => {
    this.setState((prevState) => ({
      useGooglePlaces: !prevState.useGooglePlaces,
      toggleButtonText:
        prevState.toggleButtonText === "Allow PO Box Address"
          ? "Allow Simple Address"
          : "Allow PO Box Address",
    }));
  };

  formUpdateSubmit = async () => {
    let {
      title,
      name,
      agent_email,
      agent_password,
      c_password,
      agent_phone,
      agent_company,
      agent_status,
      sharelink_limit,
      agent_address,
      agent_address2,
      agent_city,
      agent_state,
      agent_zip,
      agent_country,
      statusChanged,
      sub_agent_id,
      agent_isVerified,
      isEmailChanged,
      proceedAfterEmailModal,
    } = this.state;

    const modalBody = document.getElementById("modalFormDetail");
    if (modalBody) {
      setTimeout(() => {
        modalBody.scrollTo({
          top: 0,
          behavior: "smooth",
        });
      }, 0);
    }

    this.setState({
      proceedAfterEmailModal: false,
      showEmailWarning: false,
      successMessageEdit: "",
      errorMessageEdit: "",
    });

    this.setState({
      errorMessageEdit: "",
      errorName: "",
      errorStatus: "",
      errorAgentCompany: "",
      errorAgentEmail: "",
      errorAgentPhone: "",
      errorAgentAddress: "",
      errorAgentCity: "",
      errorAgentState: "",
      errorAgentZip: "",
      errorAgentCountry: "",
      errorAgentPassword: "",
      errorCPassword: "",
      errorPass: "",
      errorAgentSharelink: "",
    });
    let is_validated = true;
    const passwordRegex = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[\W_]).{8,}$/;
    if (this.state.name === "") {
      this.setState({
        errorName: "error",
        errorMessageEdit: "Name is required.",
      });
      is_validated = false;
    } else if (this.state.agent_company === "") {
      this.setState({
        errorAgentCompany: "error",
        errorMessageEdit: "Company name is required.",
      });
      is_validated = false;
    } else if (this.state.agent_phone === "") {
      this.setState({
        errorAgentPhone: "error",
        errorMessageEdit: "Phone is required.",
      });
      is_validated = false;
    } else if (!this.isPhoneValid(this.state.agent_phone)) {
      this.setState({
        errorAgentPhone: "error",
        errorMessageEdit: "Invalid phone format.",
      });
      is_validated = false;
    } else if (ValidateEmail(this.state.agent_email) === false) {
      this.setState({
        errorAgentEmail: "error",
        errorMessageEdit: "Invalid email format.",
      });
      is_validated = false;
    } else if (this.state.agent_password !== "") {
      if (this.state.agent_password.length < 8) {
        this.setState({
          errorAgentPassword: "error",
          errorMessageEdit: "Use 8 characters or more for your password",
        });
        is_validated = false;
      } else if (!passwordRegex.test(agent_password)) {
        this.setState({
          errorAgentPassword: "error",
          errorMessageEdit:
            "Password must be at least 8 characters, with uppercase, lowercase, number & special character.",
        });
        is_validated = false;
      } else if (this.state.c_password === "") {
        this.setState({
          errorCPassword: "error",
          errorMessageEdit: "Confirm password is required.",
        });
        is_validated = false;
      } else if (this.state.c_password.length < 8) {
        this.setState({
          errorCPassword: "error",
          errorMessageEdit:
            "Use 8 characters or more for your confirm password",
        });
        is_validated = false;
      } else if (
        this.state.agent_password.trim() != this.state.c_password.trim()
      ) {
        this.setState({
          errorCPassword: "error",
          errorMessageEdit: "Password and confirm password does not match.",
        });
        is_validated = false;
      }
    } else if (this.state.agent_address === "") {
      this.setState({
        errorAgentAddress: "error",
        errorMessageEdit: "Address is required.",
      });
      is_validated = false;
    } else if (this.state.agent_city === "") {
      this.setState({
        errorAgentCity: "error",
        errorMessageEdit: "City is required.",
      });
      is_validated = false;
    } else if (this.state.agent_state === "") {
      this.setState({
        errorAgentState: "error",
        errorMessageEdit: "State is required.",
      });
      is_validated = false;
    } else if (this.state.agent_zip === "") {
      this.setState({
        errorAgentZip: "error",
        errorMessageEdit: "Zip/postal code is required.",
      });
      is_validated = false;
    } else if (this.state.agent_country === "") {
      this.setState({
        errorAgentCountry: "error",
        errorMessageEdit: "Country is required.",
      });
      is_validated = false;
    } else if (this.state.sharelink_limit === "") {
      this.setState({
        errorAgentSharelink: "error",
        errorMessageEdit: "Share link limit is required.",
      });
      is_validated = false;
    }
    if (is_validated) {
      if (isEmailChanged && !proceedAfterEmailModal) {
        // Show the inline warning message instead of the modal
        this.setState({ showEmailWarning: true });
        return;
      }
      let apiResponce = await editSubAgent(
        auth.getAccount(),
        auth.getToken(),
        title,
        name,
        agent_email,
        agent_password,
        agent_phone,
        sub_agent_id,
        agent_company,
        agent_status,
        sharelink_limit,
        agent_address,
        agent_address2,
        agent_city,
        agent_state,
        agent_zip,
        agent_country,
        this.state.notifyCheckBox.toString(),
        statusChanged,
        agent_isVerified,
        this.state.role,
      );
      //console.log("Edit Agent RES: ", apiResponce.data);
      if (
        apiResponce.data.status === 403 ||
        apiResponce.data.errors === "authentication missing" ||
        apiResponce.data.errors === "jwt expired"
      ) {
        auth.logout();
      } else if (
        apiResponce.data.status === 409 &&
        apiResponce.data.message === "Address validation failed"
      ) {
        const formattedErrorMessage =
          Array.isArray(apiResponce.data.errors) &&
          apiResponce.data.errors.length > 0
            ? apiResponce.data.errors.join("<br />")
            : "Address validation failed";

        this.setState({
          errorMessageEdit: formattedErrorMessage,
          tableLoader: false,
        });
      } else if (
        apiResponce.data.status === 404 &&
        apiResponce.data.message === "already_assigned"
      ) {
        this.setState({
          successMessageEdit: "",
          errorMessageEdit: "Email is already registered.",
          tableLoader: false,
        });
      } else if (
        apiResponce.data.status === 200 &&
        apiResponce.data.message === "Success"
      ) {
        this.setState({
          successMessageEdit: "Sub user updated successfully.",
          errorMessageEdit: "",
          tableLoader: false,
        });
        setTimeout(() => {
          window.location.reload();
        }, 3000);
      } else if (
        apiResponce.data.status === 404 &&
        apiResponce.data.message === "fail"
      ) {
        this.setState({
          errorMessageEdit: "Something went wrong,try again later.",
          successMessageEdit: "",
          disabled: false,
          tableLoader: false,
        });
        return false;
      } else {
        this.setState({
          errorMessageEdit: "Something went wrong,try again later.",
          successMessageEdit: "",
          disabled: false,
          tableLoader: false,
        });
        //auth.logout();
      }
    }
    setTimeout(() => {
      this.setState({
        errorMessageEdit: "",
        successMessageEdit: "",
        disabled: false,
        tableLoader: false,
        notifyCheckBox: false,
      });
    }, 3000);
  };

  handleChangeCountry = (event) => {
    const country = event.label;
    this.setState({
      agent_country: country,
    });
  };

  phoneUtil = PhoneNumberUtil.getInstance();

  isPhoneValid = (phone) => {
    try {
      return this.phoneUtil.isValidNumber(
        this.phoneUtil.parseAndKeepRawInput(phone),
      );
    } catch (error) {
      return false;
    }
  };

  handleFocus = () => {
    // Move cursor to the end of the input value
    const input = this.phoneInputRef.current;
    if (input) {
      const value = input.value;
      input.setSelectionRange(value.length, value.length);
    }
  };

  handleAddressSelect = async (place) => {
    const { description } = place.value;
    try {
      const response = await fetch(
        `https://maps.googleapis.com/maps/api/geocode/json?address=${encodeURIComponent(
          description,
        )}&key=${process.env.REACT_APP_ADDRESS_AUTOCOMPLETE_API_KEY}`,
      );
      const data = await response.json();

      if (data.status === "OK") {
        const addressComponents = data.results[0].address_components;
        const formattedAddress = data.results[0].formatted_address;
        let city = null;
        let state = null;
        let country = null;
        let zipCode = null;
        let streetAddress = "";
        let neighborhood = null;
        let locality = null;
        let address2 = "";
        addressComponents.forEach((component) => {
          if (component.types.includes("neighborhood")) {
            neighborhood = component.long_name;
          } else if (component.types.includes("locality")) {
            locality = component.long_name;
          } else if (component.types.includes("administrative_area_level_1")) {
            state = component.short_name;
          } else if (component.types.includes("country")) {
            country = component.long_name;
          } else if (component.types.includes("postal_code")) {
            zipCode = component.long_name;
          } else if (component.types.includes("subpremise")) {
            address2 = component.long_name;
          } else if (
            ![
              "neighborhood",
              "sublocality",
              "sublocality_level_1",
              "sublocality_level_2",
              "administrative_area_level_2",
              "administrative_area_level_3",
              "postal_code_suffix",
            ].includes(component.types[0])
          ) {
            if (streetAddress !== "") {
              streetAddress += " ";
            }
            streetAddress += component.long_name;
          }
        });
        // Check if neighborhood is part of the formatted address
        if (neighborhood && formattedAddress.includes(neighborhood)) {
          city = neighborhood;
        } else {
          city = locality;
        }
        this.setState({
          agent_city: city && city !== "" ? city : "",
          agent_state: state && state !== "" ? state : "",
          agent_zip: zipCode && zipCode !== "" ? zipCode : "",
          agent_country: country && country !== "" ? country : "",
          agent_address:
            streetAddress && streetAddress !== "" ? streetAddress : "",
          agent_address2: address2 && address2 !== "" ? address2 : "",
        });
      } else {
        console.error("Reverse geocoding request failed:", data.status);
      }
    } catch (error) {
      console.error("Error fetching reverse geocoding data:", error);
    }
  };

  handleEmailWarningYes = () => {
    this.setState(
      {
        proceedAfterEmailModal: true,
      },
      () => {
        this.formUpdateSubmit();
      },
    );
  };

  handleEmailWarningNo = () => {
    this.setState({ showEmailWarning: false });
  };

  agentLogin = async (value, tableMeta) => {
    const agent_id = tableMeta.rowData[5];
    this.setState({
      loginErrorMessage: "",
      login_url: "",
      showLoginModal: true,
    });
    const servicesResponce = await getSubAgentLogin(
      auth.getAccount(),
      auth.getToken(),
      agent_id,
    );
    // console.log("agentLogin.data.data: ", servicesResponce.data);

    if (
      servicesResponce.data.status === 403 ||
      servicesResponce.data.errors === "authentication missing" ||
      servicesResponce.data.errors === "jwt expired"
    ) {
      auth.logout();
    } else if (
      servicesResponce.data.status === 404 &&
      servicesResponce.data.message === "inactive"
    ) {
      this.setState({
        loginErrorMessage: "Account is not active.",
      });
    } else if (
      servicesResponce.data.status === 404 &&
      servicesResponce.data.message === "notVerified"
    ) {
      this.setState({
        loginErrorMessage:
          "Account is not verifed. Please check your email and click verify link.",
      });
    } else if (
      servicesResponce.data.status === 200 &&
      servicesResponce.data.message === "success"
    ) {
      this.setState({
        login_url: servicesResponce.data.login_url,
      });

      window.open(
        `${servicesResponce.data.login_url}?${servicesResponce.data.agent_accountno}`,
        "_blank",
      );
      this.closeLoginModal();
    } else {
      this.setState({
        loginErrorMessage:
          "There is some error while authenticating the account.",
      });
    }
  };

  closeLoginModal = () => {
    this.setState({
      showLoginModal: false,
      loginErrorMessage: "",
      login_url: "",
    });
  };

  toggleLoginModal = (show) => {
    if (show) {
      this.setState({
        showLoginModal: true,
      });
    } else {
      this.closeLoginModal();
    }
  };

  preViewDefault = async () => {
    const getEmailResponse = await getEditSubAgentEmailPreview(
      auth.getAccount(),
      auth.getToken(),
    );
    // console.log("getEmailResponse: ", getEmailResponse.data);
    if (
      getEmailResponse.data.status === 403 ||
      getEmailResponse.data.errors === "authentication missing" ||
      getEmailResponse.data.errors === "jwt expired"
    ) {
      auth.logout();
    } else if (getEmailResponse.data.status === 404) {
      //window.location.replace("/error");
    } else if (
      getEmailResponse.data.status === 200 &&
      getEmailResponse.data.message === "success"
    ) {
      let emailTemplate = getEmailResponse.data.data[0][3];
      let logoUrl = getEmailResponse.data.data[0]["reseller_logo"];

      if (emailTemplate && emailTemplate !== "") {
        // Replace company logo
        emailTemplate = emailTemplate.replace(/{{comp_logo}}/g, logoUrl);

        // Replace placeholders with user input values
        emailTemplate = emailTemplate.replace(
          /{{client_name}}/g,
          this.state.name || "{{client_name}}",
        );
        emailTemplate = emailTemplate.replace(
          /{{comp_name}}/g,
          auth.getCompName() || "{{comp_name}}",
        );
        emailTemplate = emailTemplate.replace(
          /{{client_email}}/g,
          this.state.agent_email || "{{client_email}}",
        );

        // Clean up any empty paragraphs
        emailTemplate = emailTemplate.replace(/<p>&nbsp;<\/p>/g, "");
      }

      this.setState({
        email_id: getEmailResponse.data.data[0][0],
        email_title: getEmailResponse.data.data[0][1],
        email_subject: getEmailResponse.data.data[0][2],
        email_template: emailTemplate,
        tableLoader: false,
        isEditorReady: true,
      });
      window.$("#modalPreviewDefaultModal").modal("show");
    } else {
      //window.location.replace("/error");
    }
  };

  closePreviewModal = () => {
    window.$("#modalPreviewDefaultModal").modal("hide");
    setTimeout(() => {
      if (window.$("#modalFormDetail").hasClass("show")) {
        window.$("body").addClass("modal-open");
        window.$("#modalFormDetail").css("z-index", "1050");
        window.$(".modal-backdrop").last().remove();
      } else {
        window.$("body").removeClass("modal-open");
      }
    }, 300);
  };

  preViewDefaultInvite = async () => {
    const getEmailResponse = await getInviteSubAgentEmailPreview(
      auth.getAccount(),
      auth.getToken(),
    );
    // console.log("getEmailResponse: ", getEmailResponse.data);
    if (
      getEmailResponse.data.status === 403 ||
      getEmailResponse.data.errors === "authentication missing" ||
      getEmailResponse.data.errors === "jwt expired"
    ) {
      auth.logout();
    } else if (getEmailResponse.data.status === 404) {
      //window.location.replace("/error");
    } else if (
      getEmailResponse.data.status === 200 &&
      getEmailResponse.data.message === "success"
    ) {
      let emailTemplate = getEmailResponse.data.data[0][3];
      let logoUrl = getEmailResponse.data.data[0][6];

      if (emailTemplate && emailTemplate !== "") {
        // Replace company logo
        emailTemplate = emailTemplate.replace(/{{comp_logo}}/g, logoUrl);

        // Replace placeholders with user input values
        emailTemplate = emailTemplate.replace(
          /{{client_name}}/g,
          this.state.agent_name || "{{client_name}}",
        );
        emailTemplate = emailTemplate.replace(
          /{{invitation_comment}}/g,
          this.state.invitation_comment || "{{invitation_comment}}",
        );
        emailTemplate = emailTemplate.replace(
          /{{comp_name}}/g,
          auth.getCompName() || "{{comp_name}}",
        );

        // Clean up any empty paragraphs
        emailTemplate = emailTemplate.replace(/<p>&nbsp;<\/p>/g, "");
      }

      this.setState({
        email_id: getEmailResponse.data.data[0][0],
        email_title: getEmailResponse.data.data[0][1],
        email_subject: getEmailResponse.data.data[0][2],
        email_template: emailTemplate,
        tableLoader: false,
        isEditorReady: true,
      });
      window.$("#modalPreviewDefaultModalInvite").modal("show");
    } else {
      //window.location.replace("/error");
    }
  };

  closePreviewModalInvite = () => {
    window.$("#modalPreviewDefaultModalInvite").modal("hide");
  };

  togglePassword = () => {
    this.setState({
      passwordShown: !this.state.passwordShown,
    });
  };

  toggleConfirmPassword = () => {
    this.setState({
      confirmPasswordShown: !this.state.confirmPasswordShown,
    });
  };

  getCustomSettings = async () => {
    try {
      const getCustomSetting_res = await getCustomSettings(
        auth.getAccount(),
        auth.getToken(),
      );
      //console.log("getCustomSetting_res: ", getCustomSetting_res.data);
      if (
        getCustomSetting_res.data.status === 200 &&
        getCustomSetting_res.data.data &&
        getCustomSetting_res.data.data.length > 0
      ) {
        const row = getCustomSetting_res.data.data[0];
        const roleEnabled =
          row.role_field_enabled === 1 ||
          row.role_field_enabled === "1" ||
          row.role_field_enabled === true ||
          row.role_field_enabled === "Yes";
        let columnServices = [...this.state.columnServices];
        let agentTableOptions = this.state.agentTableOptions;
        if (roleEnabled) {
          const roleIndex = columnServices.findIndex((c) => c.name === "Role");
          if (roleIndex !== -1) {
            columnServices[roleIndex] = {
              ...columnServices[roleIndex],
              options: { ...columnServices[roleIndex].options, display: true },
            };
          }
          // Date Added, Title, Role, Name, Email, Status, Action
          agentTableOptions = { columnOrder: [0, 1, 6, 2, 3, 4, 5] };
        }
        this.setState({
          address_autocomplete: row.address_autocomplete || "Yes",
          address_validation: row.address_validation || "Yes",
          role_field_enabled: roleEnabled,
          columnServices,
          agentTableOptions,
        });
      }
    } catch (error) {
      console.error("Error fetching settings:", error);
    }
  };

  render() {
    const { useGooglePlaces, toggleButtonText } = this.state;
    const breadcrumb_arr = [
      {
        title: localization.specificPortals.agentsLabel,
        url: "/agents",
      },
      {
        title: "Sub Users",
        url: "",
      },
    ];
    return (
      <div className="nk-content " id="SubClients_Block">
        <div className="container-fluid">
          {/* MSA WARNING  START*/}
          {this.props.defaultSettings === "missing" &&
          this.props.from !== "dashboard" ? (
            <SettingsError />
          ) : null}
          {this.props.is_msa_signed === "No" &&
          this.props.from !== "dashboard" ? (
            <MsaWarning />
          ) : null}
          {/* MSA WARNING END */}

          <div className="nk-content-inner">
            <div className="nk-content-body">
              {/* PAGE TITLE START */}
              <div className="nk-block-head nk-block-head-sm">
                <div className="nk-block-between">
                  <div className="nk-block-head-content">
                    <h3 className="nk-block-title page-title">
                      <PageTitleBreadCrumb
                        name={breadcrumb_arr}
                        icon="icon ni ni-user-list"
                      />
                    </h3>
                  </div>
                  <div className="nk-block-head-content" id="HeadContent">
                    <div className="toggle-wrap nk-block-tools-toggle">
                      <a
                        href="#"
                        className="btn btn-icon btn-trigger toggle-expand mr-n1"
                        data-target="pageMenu"
                      >
                        <em className="icon ni ni-more-v"></em>
                      </a>
                      <div
                        className="toggle-expand-content"
                        data-content="pageMenu"
                      >
                        <ul className="nk-block-tools g-3">
                          <li className="nk-block-tools-opt">
                            <a
                              onClick={() => this.setNewAgentSettings()}
                              className="btn btn-primary"
                              style={{ color: "white" }}
                            >
                              <em className="icon ni ni-plus-round"></em>
                              &nbsp;Invite New Sub User
                            </a>
                          </li>
                          <li className="nk-block-tools-opt">
                            <a
                              href={`/agents/Addsubagent/${this.state.agent_id}`}
                              className="btn btn-primary"
                            >
                              <em className="icon ni ni-plus-round"></em>
                              &nbsp;Add New Sub User
                            </a>
                          </li>
                        </ul>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              {/* PAGE TITLE END */}

              {/* DETAIL MODAL START */}

              {/* DETAIL MODAL End */}
              <div className="nk-block">
                <div className="row g-gs">
                  {/* Table 5th Col Start */}
                  <div className="col-xxl-12">
                    <div className="row g-gs" style={{ clear: "both" }}>
                      <div className="col-lg-12">
                        <div
                          className="card card-bordered"
                          style={{ clear: "both" }}
                        >
                          <div className="card-inner">
                            <ul className="nav nav-tabs">
                              <li className="nav-item">
                                <a
                                  className={`nav-link ${
                                    this.state.activeTabCP === "tabItem7"
                                      ? "active"
                                      : ""
                                  }`}
                                  data-toggle="tab"
                                  href="#tabItem7"
                                  onClick={() =>
                                    this.handleTabClick("tabItem7")
                                  }
                                >
                                  <em className="icon ni ni-user-list"></em>
                                  <span>All Sub Users</span>
                                </a>
                              </li>
                              <li className="nav-item">
                                <a
                                  className={`nav-link ${
                                    this.state.activeTabCP === "tabItem8"
                                      ? "active"
                                      : ""
                                  }`}
                                  data-toggle="tab"
                                  href="#tabItem8"
                                  onClick={() => {
                                    this.handleTabClick("tabItem8");
                                    this.getInviteData();
                                  }}
                                >
                                  <em className="icon ni ni-user-add"></em>
                                  <span>Pending Invitations</span>
                                </a>
                              </li>
                            </ul>
                            <div
                              className="tab-content"
                              style={{ marginTop: 0 }}
                            >
                              <div
                                className={`tab-pane ${
                                  this.state.activeTabCP === "tabItem7"
                                    ? "active"
                                    : ""
                                }`}
                                id="tabItem7"
                              >
                                <div className="row">
                                  <div className="col-md-12">
                                    {this.state.tableLoader === true ? (
                                      tableLoader()
                                    ) : (
                                      <DataTable
                                        columns={this.state.columnServices}
                                        tableData={this.state.tableData}
                                        options={this.state.agentTableOptions}
                                        title="All Sub Users"
                                      />
                                    )}
                                  </div>
                                </div>
                              </div>
                              <div
                                className={`tab-pane ${
                                  this.state.activeTabCP === "tabItem8"
                                    ? "active"
                                    : ""
                                }`}
                                id="tabItem8"
                              >
                                <div className="row">
                                  <div className="col-md-12">
                                    {this.state.tableLoader === true ? (
                                      tableLoader()
                                    ) : (
                                      <DataTableExtended
                                        columns={
                                          this.state
                                            .columnServices_invitedAgents
                                        }
                                        tableData={
                                          this.state.tableData_invitedAgents
                                        }
                                        title="Pending Invitations"
                                      />
                                    )}
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  {/* Table 5th Col End */}
                  {/* Role Sub Assignment Modal START */}
                  <div
                    className="modal fade"
                    tabIndex="-1"
                    id="modalSubAgentAssignRole"
                  >
                    <div
                      className="modal-dialog modal-xl modal-dialog-top"
                      role="document"
                    >
                      <div className="modal-content">
                        <div className="modal-header">
                          <div
                            className="modal-title"
                            style={{ textAlign: "center", fontSize: "20px" }}
                          >
                            <strong>
                              <em className="icon ni ni-grid-alt"></em>Sub User
                              Menu{" "}
                              <sup>
                                <small className="text-soft">
                                  {this.state.rolesAgentName}
                                </small>
                              </sup>
                            </strong>
                          </div>
                          <a
                            href="#"
                            className="close"
                            data-dismiss="modal"
                            aria-label="Close"
                          >
                            <em className="icon ni ni-cross"></em>
                          </a>
                        </div>

                        <div className="modal-body text-left">
                          <div className="nk-modal">
                            <div className="nk-modal-text">
                              {this.state.agentRoleLoader === true ? (
                                tableLoader()
                              ) : (
                                <>
                                  {this.state.errorMessageAgentRole !== "" ? (
                                    <div
                                      className="example-alert "
                                      style={{ marginBottom: "15px" }}
                                    >
                                      <div className="alert alert-pro alert-danger">
                                        <div className="alert-text">
                                          <h4>Error</h4>
                                          <p>
                                            {this.state.errorMessageAgentRole}
                                          </p>
                                        </div>
                                      </div>
                                    </div>
                                  ) : null}
                                  {this.state.successMessageAgentRole !== "" ? (
                                    <div
                                      className="example-alert "
                                      style={{ marginBottom: "15px" }}
                                    >
                                      <div className="alert alert-pro alert-success">
                                        <div className="alert-text">
                                          <h4>Success</h4>
                                          <p>
                                            {this.state.successMessageAgentRole}
                                          </p>
                                        </div>
                                      </div>
                                    </div>
                                  ) : null}

                                  <div className="card card-bordered card-preview">
                                    <table className="table table-orders">
                                      <thead className="tb-odr-head">
                                        <tr className="tb-odr-item">
                                          <th
                                            width="35%"
                                            style={{
                                              borderRight: "1px solid #dbdfea",
                                            }}
                                          >
                                            <span className="tb-odr-action">
                                              Main Menu
                                            </span>
                                          </th>
                                          <th width="65%">
                                            <span className="tb-odr-action">
                                              Sub Menu
                                            </span>
                                          </th>
                                        </tr>
                                      </thead>
                                      <tbody className="tb-odr-body">
                                        {this.state.allRoleData &&
                                        this.state.allRoleData.length > 0 ? (
                                          <>
                                            {this.state.allRoleData.map(
                                              (role, index) => (
                                                <tr
                                                  className="tb-odr-item"
                                                  key={`role${index}`}
                                                >
                                                  <td
                                                    style={{
                                                      borderRight:
                                                        "1px solid #dbdfea",
                                                    }}
                                                  >
                                                    <FormControlLabel
                                                      control={
                                                        <Checkbox
                                                          checked={this.state.allRoleData.some(
                                                            (item) =>
                                                              item.alt ===
                                                                role.alt &&
                                                              item.isChecked,
                                                          )}
                                                          onChange={
                                                            this
                                                              .changedAllRolesRights
                                                          }
                                                          disabled={
                                                            role.seqno === 1 &&
                                                            this.state.assignRoleData.some(
                                                              (subRole) =>
                                                                role.alt ===
                                                                subRole.alt,
                                                            )
                                                          }
                                                          name={role?.id?.toString()}
                                                          color="primary"
                                                        />
                                                      }
                                                      style={{
                                                        marginBottom: "0px",
                                                      }}
                                                      label={role.alt}
                                                    />
                                                  </td>
                                                  <td
                                                    style={{
                                                      display: "flex",
                                                      flexWrap: "wrap",
                                                      paddingLeft: "16px",
                                                    }}
                                                  >
                                                    {this.state.allSubRoleData
                                                      .filter((subRole) => {
                                                        return (
                                                          subRole.role_id ===
                                                          role.id
                                                        );
                                                      })
                                                      .map(
                                                        (subRole, subIndex) => (
                                                          <div
                                                            key={`subRole${subIndex}`}
                                                          >
                                                            <FormControlLabel
                                                              control={
                                                                <Checkbox
                                                                  checked={this.state.allSubRoleData.some(
                                                                    (item) =>
                                                                      item.alt ===
                                                                        subRole.alt &&
                                                                      item.isChecked,
                                                                  )}
                                                                  onChange={
                                                                    this
                                                                      .changedAllSubRolesRights
                                                                  }
                                                                  name={subRole?.tabdetailid?.toString()}
                                                                  color="primary"
                                                                />
                                                              }
                                                              style={{
                                                                marginBottom:
                                                                  "0px",
                                                              }}
                                                              label={
                                                                subRole.alt
                                                              }
                                                            />
                                                          </div>
                                                        ),
                                                      )}
                                                  </td>
                                                </tr>
                                              ),
                                            )}
                                          </>
                                        ) : null}
                                      </tbody>
                                    </table>
                                  </div>
                                  <div className="nk-modal-action  text-right">
                                    <a
                                      href="#"
                                      className="btn btn-lg btn-mw btn-primary"
                                      onClick={() => {
                                        this.handleSubmitRoleCheckbox(
                                          this.state.checkedName,
                                          this.state.checkedEmail,
                                        );
                                      }}
                                      disabled={this.state.disableRoleBtn}
                                    >
                                      {localization.specificPortals.agentLabel}{" "}
                                      Menu
                                    </a>
                                  </div>
                                </>
                              )}
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  {/* Role Sub Assignment Modal End */}
                  {/* New Client Modal Start */}
                  <div
                    className="modal fade"
                    tabIndex="-1"
                    id="modalAddNewAgent"
                  >
                    <div
                      className="modal-dialog modal-dialog-top modal-xl"
                      role="document"
                    >
                      <div className="modal-content">
                        <a
                          href="#"
                          className="close"
                          data-dismiss="modal"
                          aria-label="Close"
                        >
                          <em className="icon ni ni-cross"></em>
                        </a>
                        <div className="modal-header">
                          <h5 className="modal-title">
                            <em
                              className="icon ni ni-user-add"
                              style={{ marginRight: "8px" }}
                            ></em>{" "}
                            Invite New Sub User
                          </h5>
                        </div>
                        <div className="modal-body">
                          {this.state.formLoader === true ? (
                            FormLoader()
                          ) : (
                            <div className="row g-4">
                              {this.state.errorMessageInvite !== "" ? (
                                <div className="col-md-12 mb-3">
                                  <div
                                    className="example-alert example-alert-revoke"
                                    style={{ marginBottom: "15px" }}
                                  >
                                    <div className="alert alert-pro alert-danger">
                                      <div className="alert-text">
                                        <h4>Error</h4>
                                        <p>{this.state.errorMessageInvite}</p>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              ) : null}
                              {this.state.successMessageInvite !== "" ? (
                                <div className="col-md-12 mb-3">
                                  <div
                                    className="example-alert example-alert-revoke"
                                    style={{ marginBottom: "15px" }}
                                  >
                                    <div className="alert alert-pro alert-success">
                                      <div className="alert-text">
                                        <h4>Success</h4>
                                        <p>{this.state.successMessageInvite}</p>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              ) : null}

                              <div className="col-md-6">
                                <div className="form-group">
                                  <div className="form-control-group">
                                    <MutextField
                                      required
                                      id="agent_name"
                                      name="agent_name"
                                      type="text"
                                      label="Full Name"
                                      defaultValue={this.state.agent_name}
                                      inputProps={{ maxLength: 64 }}
                                      onInput={(e) => {
                                        e.target.value = e.target.value.replace(
                                          /[^a-zA-Z\s'.,:\-()|!@]/gi,
                                          "",
                                        );
                                      }}
                                      helperText="Full name of the invite recipient."
                                      onChange={this.handleChange}
                                      variant="outlined"
                                      fullWidth
                                    />
                                  </div>
                                </div>
                              </div>
                              <div className="col-md-6">
                                <div className="form-group">
                                  <div className="form-control-group">
                                    <MutextField
                                      required
                                      id="agent_email"
                                      name="agent_email"
                                      type="text"
                                      label="Email Address"
                                      defaultValue={this.state.agent_email}
                                      helperText="Email address of the invite recipient."
                                      inputProps={{ maxLength: 100 }}
                                      onChange={this.handleChange}
                                      variant="outlined"
                                      fullWidth
                                    autoComplete="new-password"
                                    />
                                  </div>
                                </div>
                              </div>
                              <div className="col-md-12">
                                <div className="form-group">
                                  <div className="form-control-group">
                                    <TextareaAutosize
                                      maxrows={4}
                                      name="invitation_comment"
                                      id="invitation_comment"
                                      aria-label=""
                                      placeholder="Add Comment *"
                                      inputProps={{ maxLength: 500 }}
                                      //maxLength={500}
                                      value={this.state.invitation_comment}
                                      helperText="Maximum 500 characters"
                                      onChange={this.handleChange}
                                      style={{
                                        width: "100%",
                                        height: "100px",
                                        borderColor: "rgba(0, 0, 0, 0.125)",
                                        borderRadius: "4px",
                                        padding: "5px",
                                      }}
                                      variant="outlined"
                                    />
                                  </div>
                                </div>
                              </div>
                              <div
                                className="col-lg-12 no-padding-margin-preview"
                                style={{
                                  padding: 0,
                                  cursor: "pointer",
                                  color: "#0066cc",
                                }}
                                onClick={(e) => {
                                  e.preventDefault();
                                  this.preViewDefaultInvite();
                                }}
                              >
                                <span>Preview Notification Email </span>
                              </div>
                              <div className="col-md-12 d-flex justify-content-end">
                                <button
                                  type="button"
                                  onClick={() => this.saveNewAgent()}
                                  className="btn btn-primary"
                                  disabled={this.state.disabled}
                                >
                                  <span>Send Invite</span>{" "}
                                  <em className="icon ni ni-emails"></em>
                                </button>
                              </div>
                              <div className="col-md-12">
                                <div className="example-alert">
                                  <div className="alert alert-light">
                                    <ul className="list">
                                      <li>
                                        An email will be dispatched to the
                                        provided email address.
                                      </li>
                                      <li>
                                        This email will contain a secure,
                                        tokenized link for sub user
                                        registration.
                                      </li>
                                    </ul>
                                  </div>
                                </div>
                              </div>
                            </div>
                          )}
                        </div>
                      </div>
                    </div>
                  </div>
                  {/* New Client Modal End */}
                  {/* Modal Invitation Comment */}
                  <div
                    className="modal fade"
                    tabIndex="-1"
                    id="modalInvitationComment"
                  >
                    <div
                      className="modal-dialog modal-xl modal-dialog-top"
                      role="document"
                    >
                      <div className="modal-content">
                        <a
                          href="#"
                          className="close"
                          data-dismiss="modal"
                          aria-label="Close"
                        >
                          <em className="icon ni ni-cross"></em>
                        </a>
                        <div className="modal-header">
                          <h5 className="modal-title">Invitation Comments</h5>
                        </div>
                        <div className="modal-body">
                          <p className="text-dark">
                            {this.state.invitation_comment &&
                            this.state.invitation_comment !== ""
                              ? this.state.invitation_comment
                              : "No Comments"}
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                  {/* Modal Invitation Comment */}
                  {/* MODAL Delete Client START */}
                  <div
                    className="modal fade"
                    tabIndex="-1"
                    id="modalDeleteAlert"
                  >
                    <div className="modal-dialog" role="document">
                      <div className="modal-content">
                        <a
                          style={{ cursor: "pointer" }}
                          className="close"
                          onClick={() => {
                            this.modalHideDel();
                          }}
                        >
                          <em className="icon ni ni-cross"></em>
                        </a>
                        <div className="modal-body modal-body-lg text-center">
                          <div className="nk-modal">
                            <em className="nk-modal-icon icon icon-circle icon-circle-xxl ni ni-trash bg-success"></em>
                            <h4 className="nk-modal-title">
                              Delete Invited Sub User?
                            </h4>
                            {this.state.errorMessageInvite !== "" ? (
                              <div
                                className="example-alert"
                                style={{ marginBottom: "15px" }}
                              >
                                <div className="alert alert-pro alert-danger">
                                  <div className="alert-text">
                                    <h4>Error</h4>
                                    <p>{this.state.errorMessageInvite}</p>
                                  </div>
                                </div>
                              </div>
                            ) : null}
                            {this.state.successMessageInvite !== "" ? (
                              <div
                                className="example-alert"
                                style={{ marginBottom: "15px" }}
                              >
                                <div className="alert alert-pro alert-success">
                                  <div className="alert-text">
                                    <h4>Success</h4>
                                    <p>{this.state.successMessageInvite}</p>
                                  </div>
                                </div>
                              </div>
                            ) : null}
                            <div className="nk-modal-text">
                              <div className="caption-text">
                                Are you sure you want to delete this Sub User
                                Invitation?
                              </div>
                            </div>
                            <div className="nk-modal-action">
                              <a
                                style={{ cursor: "pointer", color: "white" }}
                                className="btn btn-lg btn-mw btn-primary"
                                onClick={() => {
                                  this.modalHideDel();
                                }}
                              >
                                CANCEL
                              </a>
                              {"  "}
                              <button
                                style={{ cursor: "pointer" }}
                                className="btn btn-lg btn-mw btn-danger"
                                onClick={() => {
                                  this.deleteInviteAgent();
                                }}
                                disabled={this.state.disabled}
                              >
                                DELETE
                              </button>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  {/* MODAL Delete Client End */}
                  {/* Resend Invitation Modal Start */}
                  <div
                    className="modal fade"
                    tabIndex="-1"
                    id="modalresendInvitation"
                  >
                    <div className="modal-dialog" role="document">
                      <div className="modal-content">
                        {this.state.successMessageInvite && (
                          <>
                            <a
                              style={{ cursor: "pointer" }}
                              className="close"
                              onClick={() => {
                                this.modalHideResend();
                              }}
                            >
                              <em className="icon ni ni-cross"></em>
                            </a>
                            <div className="modal-body modal-body-lg text-center">
                              <div className="nk-modal">
                                <em className="nk-modal-icon icon icon-circle icon-circle-xxl ni ni-check bg-success"></em>
                                <h4
                                  className="nk-modal-title"
                                  style={{ fontSize: "1.3rem" }}
                                >
                                  {this.state.successMessageInvite}
                                </h4>
                              </div>
                            </div>
                          </>
                        )}
                        {this.state.errorMessageInvite && (
                          <>
                            <a
                              style={{ cursor: "pointer" }}
                              className="close"
                              onClick={() => {
                                this.modalHideResend();
                              }}
                            >
                              <em className="icon ni ni-cross"></em>
                            </a>
                            <div className="modal-body modal-body-lg text-center">
                              <div className="nk-modal">
                                <em className="nk-modal-icon icon icon-circle icon-circle-xxl ni ni-cross bg-danger"></em>
                                <h4
                                  className="nk-modal-title"
                                  style={{ fontSize: "1.3rem" }}
                                >
                                  {this.state.errorMessageInvite}
                                </h4>
                              </div>
                            </div>
                          </>
                        )}
                      </div>
                    </div>
                  </div>
                  {/* Resend Invitation Modal Ends */}
                  {/* DETAIL MODAL End */}
                  <div
                    className="modal fade"
                    tabIndex="-1"
                    id="modalFormDetail"
                  >
                    <div
                      className="modal-dialog modal-xl modal-dialog-top"
                      role="document"
                    >
                      <div className="modal-content">
                        <div className="modal-header">
                          <h5 className="modal-title">Edit Sub User Partner</h5>
                          <a
                            href="#"
                            className="close"
                            data-dismiss="modal"
                            aria-label="Close"
                          >
                            <em className="icon ni ni-cross"></em>
                          </a>
                        </div>

                        <div className="modal-body">
                          {/* Error Start */}
                          {this.state.errorMessageEdit !== "" ? (
                            <div
                              className="example-alert"
                              style={{ marginBottom: "20px" }}
                            >
                              <div className="alert alert-pro alert-danger">
                                <div className="alert-text">
                                  <h4>Error</h4>
                                  <p
                                    dangerouslySetInnerHTML={{
                                      __html: this.state.errorMessageEdit,
                                    }}
                                  ></p>
                                </div>
                              </div>
                            </div>
                          ) : null}
                          {this.state.successMessageEdit !== "" ? (
                            <div
                              className="example-alert"
                              style={{ marginBottom: "20px" }}
                            >
                              <div className="alert alert-pro alert-success">
                                <div className="alert-text">
                                  <h4>Success</h4>
                                  <p>{this.state.successMessageEdit}</p>
                                </div>
                              </div>
                            </div>
                          ) : null}
                          {this.state.showEmailWarning && (
                            <div className="alert alert-pro alert-warning">
                              <div className="alert-text">
                                <h6>Confirm Email Update</h6>
                                <p>
                                  Are you sure you want to update the email?
                                </p>
                                <div
                                  style={{
                                    display: "flex",
                                    justifyContent: "flex-end",
                                    gap: "10px",
                                  }}
                                >
                                  <button
                                    className="btn btn-danger"
                                    onClick={this.handleEmailWarningNo}
                                  >
                                    Cancel
                                  </button>
                                  <button
                                    className="btn btn-primary"
                                    onClick={this.handleEmailWarningYes}
                                  >
                                    Yes, Proceed
                                  </button>
                                </div>
                              </div>
                            </div>
                          )}

                          <br />
                          <div className="row g-4">
                            <form method="post" autoComplete="off" role="presentation" encType="multipart/form-data">
                              <div className="row g-4">
                                <div className="col-lg-4">
                                  <div className="form-group">
                                    <TextField
                                      label="Company Name"
                                      error={this.state.errorAgentCompany}
                                      id="agent_company"
                                      name="agent_company"
                                      value={this.state.agent_company}
                                      placeholder="Company Name"
                                      change={this.handleChange}
                                      type="text"
                                      maxLength={100}
                                    autoComplete="new-password"
                                    />
                                    <small
                                      className="form-text text-muted"
                                      style={{
                                        position: "absolute",
                                        top: "80px",
                                        color: "#555",
                                        fontSize: "0.75rem",
                                        fontWeight: "400",
                                        fontFamily:
                                          '"Roboto", "Helvetica", "Arial", sans-serif',
                                      }}
                                    >
                                      Allowed characters: (&nbsp; _ &nbsp; .
                                      &nbsp; - &nbsp; , &nbsp; : &nbsp; &amp;
                                      &nbsp; ( ) &nbsp; | &nbsp; ! &nbsp; @ )
                                    </small>
                                  </div>
                                </div>
                                <div className="col-lg-4">
                                  <div className="form-group">
                                    <TextField
                                      label="Name"
                                      error={this.state.errorName}
                                      id="name"
                                      name="name"
                                      value={this.state.name}
                                      placeholder="Full Name"
                                      change={this.handleChange}
                                      maxLength={100}
                                    autoComplete="new-password"
                                    />
                                    <small
                                      className="form-text text-muted"
                                      style={{
                                        position: "absolute",
                                        top: "80px",
                                        color: "#555",
                                        fontSize: "0.75rem",
                                        fontWeight: "400",
                                        fontFamily:
                                          '"Roboto", "Helvetica", "Arial", sans-serif',
                                      }}
                                    >
                                      Allowed characters: (&nbsp; ' &nbsp; -
                                      &nbsp; . &nbsp; , &nbsp; : &nbsp; ( )
                                      &nbsp; | &nbsp; ! &nbsp; @ )
                                    </small>
                                  </div>
                                </div>

                                <div className="col-lg-4">
                                  <div className="form-group">
                                    <TextField
                                      label="Title"
                                      id="title"
                                      name="title"
                                      value={this.state.title}
                                      placeholder="Title"
                                      change={this.handleChange}
                                      maxLength={30}
                                    autoComplete="new-password"
                                    />
                                    <small
                                      className="form-text text-muted"
                                      style={{
                                        position: "absolute",
                                        top: "80px",
                                        color: "#555",
                                        fontSize: "0.75rem",
                                        fontWeight: "400",
                                        fontFamily:
                                          '"Roboto", "Helvetica", "Arial", sans-serif',
                                      }}
                                    >
                                      Allowed characters: (&nbsp; _ &nbsp; -
                                      &nbsp; . &nbsp; &amp; &nbsp; , &nbsp; :
                                      &nbsp; ( ) &nbsp; | &nbsp; ! &nbsp; @ )
                                    </small>
                                  </div>
                                </div>

                                {this.state.role_field_enabled ? (
                                  <div className="col-lg-4">
                                    <div className="form-group">
                                      <TextField
                                        label="Role"
                                        id="role"
                                        name="role"
                                        value={this.state.role}
                                        placeholder="Role"
                                        change={this.handleChange}
                                        maxLength={30}
                                      />
                                    </div>
                                  </div>
                                ) : null}

                                <div className="col-lg-4">
                                  <div className="form-group">
                                    <TextField
                                      label="Email"
                                      type="text"
                                      id="agent_email"
                                      name="agent_email"
                                      value={this.state.agent_email}
                                      placeholder="Enter email address"
                                      change={this.handleChange}
                                      //disabled={true}
                                    autoComplete="new-password"
                                    />
                                  </div>
                                </div>
                                <div className="col-lg-4">
                                  <div className="form-group">
                                    <PhoneInput
                                      required
                                      defaultCountry={"us"}
                                      inputProps={{
                                        name: "agent_phone",
                                        id: "agent_phone",
                                        maxLength: 20,
                                        style: this.state.errorAgentPhone
                                          ? { borderColor: "red" }
                                          : {},
                                      }}
                                      style={{
                                        marginTop: "30px",
                                        height: "45px",
                                      }}
                                      value={
                                        this.state.isLoading
                                          ? ""
                                          : this.state.agent_phone
                                      }
                                      placeholder={
                                        this.state.isLoading
                                          ? "Loading..."
                                          : "Enter the phone number"
                                      }
                                      onChange={(value) =>
                                        this.handleChange({
                                          target: {
                                            name: "agent_phone",
                                            value,
                                          },
                                        })
                                      }
                                      helperText="Enter the phone number."
                                      label="Client Phone Number"
                                      ref={this.phoneInputRef}
                                      onFocus={this.handleFocus}
                                    />
                                  </div>
                                </div>

                                <div className="col-md-4">
                                  <div className="form-group">
                                    <label
                                      className="text-dark"
                                      style={{
                                        marginBottom: "0.5rem",
                                        fontWeight: "600",
                                      }}
                                    >
                                      Account Status
                                    </label>
                                    <select
                                      className="form-control form-control-lg"
                                      id="agent_status"
                                      name="agent_status"
                                      value={this.state.agent_status}
                                      onChange={this.handleChange}
                                    >
                                      <option key="status1" value="1">
                                        Active
                                      </option>
                                      <option key="status0" value="0">
                                        Inactive
                                      </option>
                                    </select>
                                  </div>
                                </div>

                                <div className="col-lg-4">
                                  <div className="nk-block-between-md g-4">
                                    <div className="nk-block-head-content">
                                      <label
                                        htmlFor="googleLocation-autocomplete"
                                        style={{
                                          color: "black",
                                          fontWeight: "500",
                                          marginBottom: "8px",
                                        }}
                                      >
                                        Address *
                                      </label>
                                    </div>
                                    {this.state.address_autocomplete ===
                                      "Yes" && (
                                      <div className="nk-block-head-content">
                                        <ul className="nk-block-tools gx-3">
                                          <li>
                                            <a
                                              onClick={this.handleToggle}
                                              className="text-primary fs-11"
                                              style={{
                                                cursor: "pointer",
                                                fontSize: "11px",
                                              }}
                                            >
                                              {toggleButtonText}
                                            </a>
                                          </li>
                                        </ul>
                                      </div>
                                    )}
                                  </div>
                                  <div className="form-group">
                                    {this.state.address_autocomplete ===
                                    "Yes" ? (
                                      useGooglePlaces ? (
                                        <GooglePlacesAutocomplete
                                          apiKey={
                                            process.env
                                              .REACT_APP_ADDRESS_AUTOCOMPLETE_API_KEY
                                          }
                                          apiOptions={{ loading: 'async' }}
                                          selectProps={{
                                            value: this.state.agent_address
                                              ? {
                                                  label:
                                                    this.state.agent_address,
                                                  value:
                                                    this.state.agent_address,
                                                }
                                              : null,
                                            onChange: this.handleAddressSelect,
                                            placeholder: this.state
                                              .agent_address
                                              ? null
                                              : "Enter your address..",
                                            styles: {
                                              control: (provided) => ({
                                                ...provided,
                                                minHeight: "43px",
                                              }),
                                            },
                                          }}
                                          className="googleLocation-autocomplete"
                                        />
                                      ) : (
                                        <input
                                          type="text"
                                          className="form-control form-control-lg"
                                          id="agent_address"
                                          name="agent_address"
                                          value={this.state.agent_address}
                                          onChange={this.handleChange}
                                          placeholder="PO Box Address"
                                          //maxLength={50}
                                          inputProps={{ maxLength: 50 }}
                                          fullWidth
                                          error={
                                            this.state.errorAgentAddress ===
                                            "error"
                                          }
                                        autoComplete="new-password" />
                                      )
                                    ) : (
                                      // address_autocomplete === "No" → show PO Box only
                                      <input
                                        type="text"
                                        className="form-control form-control-lg"
                                        id="agent_address"
                                        name="agent_address"
                                        value={this.state.agent_address}
                                        onChange={this.handleChange}
                                        placeholder="Enter your address"
                                        fullWidth
                                        error={
                                          this.state.errorAgentAddress ===
                                          "error"
                                        }
                                      autoComplete="new-password" />
                                    )}
                                    {/*  */}
                                  </div>
                                </div>

                                <div className="col-lg-4">
                                  <div className="form-group">
                                    <TextField
                                      label="Apartment, Suite, Etc."
                                      type="text"
                                      id="agent_address2"
                                      name="agent_address2"
                                      value={this.state.agent_address2}
                                      placeholder=""
                                      change={this.handleChange}
                                      maxLength={100}
                                    autoComplete="new-password"
                                    />
                                  </div>
                                </div>

                                <div className="col-md-4">
                                  <div className="form-group">
                                    <label
                                      className="text-dark"
                                      style={{
                                        marginBottom: "0.5rem",
                                        fontWeight: "600",
                                      }}
                                    >
                                      Verify Account
                                    </label>
                                    <select
                                      className="form-control form-control-lg"
                                      id="agent_isVerified"
                                      name="agent_isVerified"
                                      value={this.state.agent_isVerified}
                                      onChange={this.handleChange}
                                    >
                                      <option key="status1" value="Yes">
                                        Yes
                                      </option>
                                      <option key="status0" value="No">
                                        No
                                      </option>
                                    </select>
                                  </div>
                                </div>

                                <div className="col-lg-2">
                                  <div className="form-group">
                                    <TextField
                                      label="City"
                                      type="text"
                                      error={this.state.errorAgentCity}
                                      id="agent_city"
                                      name="agent_city"
                                      value={this.state.agent_city}
                                      placeholder="Enter city"
                                      change={this.handleChange}
                                      maxLength={32}
                                    autoComplete="new-password"
                                    />
                                  </div>
                                </div>
                                <div className="col-lg-2">
                                  <div className="form-group">
                                    <TextField
                                      label="State"
                                      type="text"
                                      error={this.state.errorAgentState}
                                      id="agent_state"
                                      name="agent_state"
                                      value={this.state.agent_state}
                                      placeholder="Enter state"
                                      change={this.handleChange}
                                      maxLength={32}
                                    autoComplete="new-password"
                                    />
                                  </div>
                                </div>
                                <div className="col-lg-4">
                                  <div className="form-group">
                                    <TextField
                                      label="Zip Code"
                                      type="text"
                                      error={this.state.errorAgentZip}
                                      id="agent_zip"
                                      name="agent_zip"
                                      value={this.state.agent_zip}
                                      placeholder="Enter zip code"
                                      change={this.handleChange}
                                      maxLength={9}
                                    autoComplete="new-password"
                                    />
                                  </div>
                                </div>

                                <div className="col-lg-4">
                                  <div className="form-group">
                                    <label
                                      className="text-dark"
                                      style={{
                                        marginBottom: "0.5rem",
                                        fontWeight: "600",
                                      }}
                                    >
                                      Country
                                    </label>
                                    <Select
                                      id="agent_country"
                                      name="agent_country"
                                      className="customCountrySelect"
                                      options={this.countryOptions}
                                      value={{
                                        label: this.state.agent_country,
                                        value: this.state.agent_country,
                                      }}
                                      onChange={this.handleChangeCountry}
                                      placeholder="Select country"
                                    />
                                  </div>
                                </div>
                                {/* Keep Password & Confirm Password side by side regardless of the
                                    optional Role field shifting the grid. */}
                                <div className="w-100"></div>
                                <div className="col-md-4">
                                  <div className="form-group">
                                    <TextField
                                      label={
                                        <Tooltip
                                          title="Password must be at least 8 characters, with uppercase, lowercase, number & special character."
                                          placement="top"
                                        autoComplete="new-password"
                                        >
                                          <span>
                                            <span>
                                              <em
                                                className="icon ni ni-info"
                                                style={{ marginRight: 5 }}
                                              ></em>
                                            </span>
                                            Password
                                          </span>
                                        </Tooltip>
                                      }
                                      type={
                                        this.state.passwordShown
                                          ? "text"
                                          : "password"
                                      }
                                      error={this.state.errorClientPass}
                                      id="agent_password"
                                      name="agent_password"
                                      value={this.state.agent_password}
                                      placeholder="Enter password"
                                      change={this.handleChange}
                                      maxLength={30}
                                    />
                                    <a
                                      style={{
                                        left: "auto",
                                        right: "2px",
                                        top: "53px",
                                        position: "absolute",
                                        cursor: "pointer",
                                      }}
                                      tabIndex="-1"
                                      onClick={this.togglePassword}
                                      className="form-icon form-icon-right passcode-switch"
                                      data-target="password"
                                    >
                                      {this.state.passwordShown ? (
                                        <em className="icon ni ni-eye-off"></em>
                                      ) : (
                                        <em className="icon ni ni-eye"></em>
                                      )}
                                    </a>
                                    <PasswordStrengthBar
                                      password={this.state.agent_password}
                                    />
                                  </div>
                                </div>
                                <div className="col-md-4">
                                  <div className="form-group">
                                    <TextField
                                      label={
                                        <Tooltip
                                          title="Confirm Password must be at least 8 characters, with uppercase, lowercase, number & special character. Confirm Password must match the Password."
                                          placement="top"
                                        autoComplete="new-password"
                                        >
                                          <span>
                                            <span>
                                              <em
                                                className="icon ni ni-info"
                                                style={{ marginRight: 5 }}
                                              ></em>
                                            </span>
                                            Confirm Password
                                          </span>
                                        </Tooltip>
                                      }
                                      type={
                                        this.state.confirmPasswordShown
                                          ? "text"
                                          : "password"
                                      }
                                      error={this.state.errorClientPass}
                                      id="c_password"
                                      name="c_password"
                                      value={this.state.c_password}
                                      placeholder="Enter confirm password"
                                      change={this.handleChange}
                                      maxLength={30}
                                    />
                                    <a
                                      style={{
                                        left: "auto",
                                        right: "2px",
                                        top: "53px",
                                        position: "absolute",
                                        cursor: "pointer",
                                      }}
                                      tabIndex="-1"
                                      onClick={() => {
                                        this.toggleConfirmPassword();
                                      }}
                                      className="form-icon form-icon-right passcode-switch"
                                      data-target="password"
                                    >
                                      {this.state.confirmPasswordShown ? (
                                        <em className="icon ni ni-eye-off"></em>
                                      ) : (
                                        <em className="icon ni ni-eye"></em>
                                      )}
                                    </a>
                                  </div>
                                </div>

                                <div className="col-md-4">
                                  <div className="form-group">
                                    <TextField
                                      label={`${localization.specificPortals.sharelinkLabel} Limit`}
                                      type="text"
                                      error={
                                        this.state.errorAgentSharelink ===
                                        "error"
                                      }
                                      id="sharelink_limit"
                                      name="sharelink_limit"
                                      value={this.state.sharelink_limit}
                                      placeholder="Enter zip code"
                                      change={this.handleChange}
                                      maxLength={2}
                                      onKeyPress={() => {
                                        this.checkNumber();
                                      }}
                                      autoComplete="new-password"
                                    />
                                  </div>
                                </div>

                                <div className="form-group col-md-4">
                                  <div
                                    className="custom-control custom-control-lg custom-checkbox"
                                    style={{ padding: 0, marginLeft: "3rem" }}
                                  >
                                    <input
                                      type="checkbox"
                                      className="custom-control-input"
                                      id="customCheck2"
                                      onChange={() => {
                                        const isChecked =
                                          !this.state.notifyCheckBox;
                                        this.setState({
                                          notifyCheckBox: isChecked,
                                        });
                                        // console.log(
                                        //   "Notify Checkbox Checked:",
                                        //   isChecked
                                        // );
                                      }}
                                    />

                                    <label
                                      className="custom-control-label"
                                      for="customCheck2"
                                    >
                                      Notify Sub User
                                    </label>
                                  </div>
                                </div>
                                <div
                                  className="col-lg-12 no-padding-margin-preview"
                                  style={{
                                    padding: 0,
                                    cursor: "pointer",
                                    color: "#0066cc",
                                  }}
                                  onClick={(e) => {
                                    e.preventDefault();
                                    this.preViewDefault();
                                  }}
                                >
                                  <span>Preview Notification Email </span>
                                </div>
                                <div style={{ clear: "both" }}></div>
                                <hr />
                                <div className="form-group text-right col-md-12">
                                  <button
                                    className="btn btn-lg btn-primary"
                                    type="button"
                                    disabled={this.state.disabled}
                                    onClick={this.formUpdateSubmit}
                                  >
                                    Submit
                                  </button>
                                </div>
                              </div>
                            </form>
                          </div>

                          {/* </form> */}
                        </div>
                      </div>
                    </div>
                  </div>
                  {/* DETAIL MODAL START */}
                  {/* PREVIEW DEFAULT MODAL  */}
                  <div
                    className="modal fade"
                    tabIndex="-1"
                    id="modalPreviewDefaultModal"
                    style={{ zIndex: "9999" }}
                  >
                    <div
                      className="modal-dialog modal-dialog-top modal-xl"
                      role="document"
                    >
                      <div className="modal-content">
                        <div
                          className="modal-header"
                          style={{ borderBottom: "1px solid #e5e9f2" }}
                        >
                          <h5
                            className="modal-title"
                            style={{
                              fontFamily: "'DM Sans', sans-serif",
                              fontWeight: "700",
                              fontSize: "1.25rem",
                              color: "#364a63",
                            }}
                          >
                            Preview Notification Email
                          </h5>
                          <a
                            style={{ cursor: "pointer" }}
                            className="close"
                            onClick={() => this.closePreviewModal()}
                          >
                            <em className="icon ni ni-cross"></em>
                          </a>
                        </div>
                        <div
                          className="modal-body"
                          style={{ padding: "1.5rem" }}
                        >
                          <div className="nk-block">
                            <div className="card card-bordered">
                              <div className="card-inner">
                                <div
                                  className="email-preview"
                                  style={{
                                    maxHeight: "60vh",
                                    overflow: "auto",
                                    padding: "1rem",
                                    backgroundColor: "#f5f6fa",
                                    borderRadius: "4px",
                                  }}
                                >
                                  {this.state.isEditorReady ? (
                                    <div
                                      className="email-preview-content"
                                      style={{
                                        fontFamily: "'Roboto', sans-serif",
                                        fontSize: "14px",
                                        lineHeight: "1.65",
                                        pointerEvents: "none",
                                        userSelect: "none",
                                      }}
                                      dangerouslySetInnerHTML={{
                                        __html: this.state.email_template,
                                      }}
                                    />
                                  ) : (
                                    tableLoader()
                                  )}
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div
                          className="modal-footer"
                          style={{
                            borderTop: "1px solid #e5e9f2",
                            padding: "1rem 1.5rem",
                          }}
                        >
                          <button
                            onClick={() => this.closePreviewModal()}
                            className="btn btn-primary"
                            style={{
                              fontFamily: "'DM Sans', sans-serif",
                              fontWeight: "500",
                            }}
                          >
                            Close
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                  {/* PREVIEW DEFAULT MODAL  */}
                  {/* PREVIEW DEFAULT MODAL  */}
                  <div
                    className="modal fade"
                    tabIndex="-1"
                    id="modalPreviewDefaultModalInvite"
                    style={{ zIndex: "9999" }}
                  >
                    <div
                      className="modal-dialog modal-dialog-top modal-xl"
                      role="document"
                    >
                      <div className="modal-content">
                        <div
                          className="modal-header"
                          style={{ borderBottom: "1px solid #e5e9f2" }}
                        >
                          <h5
                            className="modal-title"
                            style={{
                              fontFamily: "'DM Sans', sans-serif",
                              fontWeight: "700",
                              fontSize: "1.25rem",
                              color: "#364a63",
                            }}
                          >
                            Preview Notification Email
                          </h5>
                          <a
                            style={{ cursor: "pointer" }}
                            className="close"
                            onClick={() => this.closePreviewModalInvite()}
                          >
                            <em className="icon ni ni-cross"></em>
                          </a>
                        </div>
                        <div
                          className="modal-body"
                          style={{ padding: "1.5rem" }}
                        >
                          <div className="nk-block">
                            <div className="card card-bordered">
                              <div className="card-inner">
                                <div
                                  className="email-preview"
                                  style={{
                                    maxHeight: "60vh",
                                    overflow: "auto",
                                    padding: "1rem",
                                    backgroundColor: "#f5f6fa",
                                    borderRadius: "4px",
                                  }}
                                >
                                  {this.state.isEditorReady ? (
                                    <div>
                                      <style>
                                        {`
                                        .email-preview-content button,
                                        .email-preview-content a {
                                          pointer-events: none !important;
                                          cursor: not-allowed !important;
                                          text-decoration: none;
                                        }
                                      `}
                                      </style>
                                      <div
                                        className="email-preview-content"
                                        style={{
                                          fontFamily: "'Roboto', sans-serif",
                                          fontSize: "14px",
                                          lineHeight: "1.65",
                                          pointerEvents: "none",
                                          userSelect: "none",
                                        }}
                                        dangerouslySetInnerHTML={{
                                          __html: this.state.email_template,
                                        }}
                                      />
                                    </div>
                                  ) : (
                                    tableLoader()
                                  )}
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div
                          className="modal-footer"
                          style={{
                            borderTop: "1px solid #e5e9f2",
                            padding: "1rem 1.5rem",
                          }}
                        >
                          <button
                            onClick={() => this.closePreviewModalInvite()}
                            className="btn btn-primary"
                            style={{
                              fontFamily: "'DM Sans', sans-serif",
                              fontWeight: "500",
                            }}
                          >
                            Close
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                  {/* PREVIEW DEFAULT MODAL  */}
                  {/** Login Modal Start **/}
                  {this.state.showLoginModal && (
                    <div
                      className="modal fade show"
                      tabIndex="-1"
                      id="modalDefaultLogin"
                      style={{ display: "block" }}
                      role="dialog"
                    >
                      <div
                        className="modal-dialog modal-dialog-top modal-xl"
                        role="document"
                      >
                        <div className="modal-content">
                          <a
                            onClick={() => this.closeLoginModal()}
                            className="close"
                            style={{ cursor: "pointer" }}
                            aria-label="Close"
                          >
                            <em className="icon ni ni-cross"></em>
                          </a>
                          <div className="modal-header">
                            <h5 className="modal-title">
                              <em
                                className="icon ni ni-user-list"
                                style={{ marginRight: "15px" }}
                              ></em>{" "}
                              Login to the Sub User
                            </h5>
                          </div>
                          <div className="modal-body">
                            {this.state.loginErrorMessage === "" ? (
                              <div className="alert alert-pro alert-primary">
                                <div className="alert-text">
                                  <h6>Connecting.....</h6>
                                  <p>
                                    Please wait while we are connecting to the{" "}
                                    {localization.specificPortals.agentText}{" "}
                                    login. You will be redirected to the Sub
                                    User dashboard after the authentication.
                                  </p>
                                </div>
                              </div>
                            ) : null}
                            {this.state.loginErrorMessage !== "" ? (
                              <div className="alert alert-pro alert-danger">
                                <div className="alert-text">
                                  <h6>Login Error</h6>
                                  <p>{this.state.loginErrorMessage}</p>
                                </div>
                              </div>
                            ) : null}
                          </div>
                        </div>
                      </div>
                    </div>
                  )}
                  {this.state.showLoginModal && (
                    <div className="modal-backdrop fade show"></div>
                  )}
                  {/** Login Modal End **/}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    defaultSettings: state.settings,
    is_msa_signed: state.is_msa_signed,
  };
};
const mapDispatchToProps = (dispatch) => {
  return {
    addSettings: (payload) => dispatch(addSettings(payload)),
  };
};
export default connect(mapStateToProps, mapDispatchToProps)(Subagents);
